import React from "react";
import {
    useReactTable,
    flexRender,
    getCoreRowModel,
    getSortedRowModel,
} from "@tanstack/react-table";
import { Typography } from "@mui/material";
import { useState } from 'react';


const columns = [
    {
        id: "name",
        header: "Name",
        accessorKey: "name",
        enableSorting: true,  // Enable sorting for this column
        // cell: ({ row }) => {
        //     const productLink = row.original.link; // Access the productLink from the row data
        //     return (
        //         <a href={productLink} target="_blank" rel="noopener noreferrer">
        //             {row.original.name}
        //         </a>
        //     );
        // },
    },
    {
        id: "imageUrl",
        header: "Image",
        accessorKey: "imageUrl",
        cell: ({ getValue }) => <img src={getValue()} alt="Product" width={50} />,
        enableSorting: false,  // Enable sorting for this column
    },
    {
        id: "model",
        header: "Model",
        accessorKey: "model",
    },
    {
        id: 'Brand',
        header: 'Brand',
        accessorKey: 'Brand',
        enableSorting: true,
        sortUndefined: 'last',
        cell: ({ getValue }) => {
            const value = getValue() || 'N/A';  // Ensure empty values are shown as "N/A"
            return value;
        }
    },
    {
        id: 'Color',
        header: 'Color',
        accessorKey: 'Color',
        enableSorting: true,
        sortUndefined: 'last',
        cell: ({ getValue }) => {
            const value = getValue() || 'N/A';  // Ensure empty values are shown as "N/A"
            return value;
        }

    },
    {
        id: "Noise Cancelling (Active)",
        header: "Noise Cancelling (Active)",
        accessorKey: "Noise Cancelling (Active)",
        enableSorting: true,
        sortUndefined: 'last',
        cell: ({ getValue }) => {
            const value = getValue() || 'N/A';  // Ensure empty values are shown as "N/A"
            return value;
        }
    },
    {
        id: 'Sound Mode',
        header: 'Sound Mode',
        accessorKey: 'Sound Mode',
        enableSorting: true,
        sortUndefined: 'last',
        cell: ({ getValue }) => {
            const value = getValue() || 'N/A';  // Ensure empty values are shown as "N/A"
            return value;
        }
    },
    {
        id: 'Connection Type',
        header: 'Connection Type',
        accessorKey: 'Connection Type',
        enableSorting: true,
        sortUndefined: 'last',
        cell: ({ getValue }) => {
            const value = getValue() || 'N/A';  // Ensure empty values are shown as "N/A"
            return value;
        }
    },
    {
        id: 'Wireless Connectivity',
        header: 'Wireless Connectivity',
        accessorKey: 'Wireless Connectivity',
        enableSorting: true,
        sortUndefined: 'last',
        cell: ({ getValue }) => {
            const value = getValue() || 'N/A';  // Ensure empty values are shown as "N/A"
            return value;
        }
    },
    {
        id: 'Maximum Wireless Range',
        header: 'Maximum Wireless Range',
        accessorKey: 'Maximum Wireless Range',
        enableSorting: true,
        sortUndefined: 'last',
        cell: ({ getValue }) => {
            const value = getValue() || 'N/A';  // Ensure empty values are shown as "N/A"
            return value;
        }
    },
    {
        id: 'Built-In Microphone',
        header: 'Built-In Microphone',
        accessorKey: 'Built-In Microphone',
        enableSorting: true,
        sortUndefined: 'last',
        cell: ({ getValue }) => {
            const value = getValue() || 'N/A';  // Ensure empty values are shown as "N/A"
            return value;
        }
    },
    {
        id: 'Carrying Case',
        header: 'Carrying Case',
        accessorKey: 'Carrying Case',
        enableSorting: true,
        sortUndefined: 'last',
        cell: ({ getValue }) => {
            const value = getValue() || 'N/A';  // Ensure empty values are shown as "N/A"
            return value;
        }
    },
    {
        id: 'Microphone Features',
        header: 'Microphone Features',
        accessorKey: 'Microphone Features',
        enableSorting: true,
        sortUndefined: 'last',
        cell: ({ getValue }) => {
            const value = getValue() || 'N/A';  // Ensure empty values are shown as "N/A"
            return value;
        }
    },
    {
        id: 'Headphone Fit',
        header: 'Headphone Fit',
        accessorKey: 'Headphone Fit',
        enableSorting: true,
        sortUndefined: 'last',
        cell: ({ getValue }) => {
            const value = getValue() || 'N/A';  // Ensure empty values are shown as "N/A"
            return value;
        }
    },
    {
        id: 'Adjustable Headband',
        header: 'Adjustable Headband',
        accessorKey: 'Adjustable Headband',
        enableSorting: true,
        sortUndefined: 'last',
        cell: ({ getValue }) => {
            const value = getValue() || 'N/A';  // Ensure empty values are shown as "N/A"
            return value;
        }
    },
    {
        id: 'Battery Life',
        header: 'Battery Life',
        accessorKey: 'Battery Life',
        enableSorting: true,
        sortUndefined: 'last',
        cell: ({ getValue }) => {
            const value = getValue() || 'N/A';  // Ensure empty values are shown as "N/A"
            return value;
        }
    },
    {
        id: 'Battery Charge Time',
        header: 'Battery Charge Time',
        accessorKey: 'Battery Charge Time',
        enableSorting: true,
        sortUndefined: 'last',
        cell: ({ getValue }) => {
            const value = getValue() || 'N/A';  // Ensure empty values are shown as "N/A"
            return value;
        }
    },
    {
        id: 'Compatible Platform(s)',
        header: 'Compatible Platform(s)',
        accessorKey: 'Compatible Platform(s)',
        enableSorting: true,
        sortUndefined: 'last',
        cell: ({ getValue }) => {
            const value = getValue() || 'N/A';  // Ensure empty values are shown as "N/A"
            return value;
        }
    },
    {
        id: 'Sound Isolating',
        header: 'Sound Isolating',
        accessorKey: 'Sound Isolating',
        enableSorting: true,
        sortUndefined: 'last',
        cell: ({ getValue }) => {
            const value = getValue() || 'N/A';  // Ensure empty values are shown as "N/A"
            return value;
        }
    },
    {
        id: 'Environmental Noise Control',
        header: 'Environmental Noise Control',
        accessorKey: 'Environmental Noise Control',
        enableSorting: true,
        sortUndefined: 'last',
        cell: ({ getValue }) => {
            const value = getValue() || 'N/A';  // Ensure empty values are shown as "N/A"
            return value;
        }
    },
    {
        id: 'Minimum Frequency Response',
        header: 'Minimum Frequency Response',
        accessorKey: 'Minimum Frequency Response',
        enableSorting: true,
        sortUndefined: 'last',
        cell: ({ getValue }) => {
            const value = getValue() || 'N/A';  // Ensure empty values are shown as "N/A"
            return value;
        }
    },
    {
        id: 'Maximum Frequency Response',
        header: 'Maximum Frequency Response',
        accessorKey: 'Maximum Frequency Response',
        enableSorting: true,
        sortUndefined: 'last',
        cell: ({ getValue }) => {
            const value = getValue() || 'N/A';  // Ensure empty values are shown as "N/A"
            return value;
        }
    },
    {
        id: 'Sensitivity',
        header: 'Sensitivity',
        accessorKey: 'Sensitivity',
        enableSorting: true,
        sortUndefined: 'last',
        cell: ({ getValue }) => {
            const value = getValue() || 'N/A';  // Ensure empty values are shown as "N/A"
            return value;
        }
    },
    {
        id: 'Integrated Amplifier',
        header: 'Integrated Amplifier',
        accessorKey: 'Integrated Amplifier',
        enableSorting: true,
        sortUndefined: 'last',
        cell: ({ getValue }) => {
            const value = getValue() || 'N/A';  // Ensure empty values are shown as "N/A"
            return value;
        }
    },
    {
        id: 'Driver Size',
        header: 'Driver Size',
        accessorKey: 'Driver Size',
        enableSorting: true,
        sortUndefined: 'last',
        cell: ({ getValue }) => {
            const value = getValue() || 'N/A';  // Ensure empty values are shown as "N/A"
            return value;
        }
    },
    {
        id: 'Bluetooth Version',
        header: 'Bluetooth Version',
        accessorKey: 'Bluetooth Version',
        enableSorting: true,
        sortUndefined: 'last',
        cell: ({ getValue }) => {
            const value = getValue() || 'N/A';  // Ensure empty values are shown as "N/A"
            return value;
        }
    },
    {
        id: 'Controls',
        header: 'Controls',
        accessorKey: 'Controls',
        enableSorting: true,
        sortUndefined: 'last',
        cell: ({ getValue }) => {
            const value = getValue() || 'N/A';  // Ensure empty values are shown as "N/A"
            return value;
        }
    },
    {
        id: 'High Resolution Audio',
        header: 'High Resolution Audio',
        accessorKey: 'High Resolution Audio',
        enableSorting: true,
        sortUndefined: 'last',
        cell: ({ getValue }) => {
            const value = getValue() || 'N/A';  // Ensure empty values are shown as "N/A"
            return value;
        }
    },
    {
        id: 'Foldable Design',
        header: 'Foldable Design',
        accessorKey: 'Foldable Design',
        enableSorting: true,
        sortUndefined: 'last',
        cell: ({ getValue }) => {
            const value = getValue() || 'N/A';  // Ensure empty values are shown as "N/A"
            return value;
        }
    },
    {
        id: 'Fast Charging',
        header: 'Fast Charging',
        accessorKey: 'Fast Charging',
        enableSorting: true,
        sortUndefined: 'last',
        cell: ({ getValue }) => {
            const value = getValue() || 'N/A';  // Ensure empty values are shown as "N/A"
            return value;
        }
    },
    {
        id: 'On/Off Switch',
        header: 'On/Off Switch',
        accessorKey: 'On/Off Switch',
        enableSorting: true,
        sortUndefined: 'last',
        cell: ({ getValue }) => {
            const value = getValue() || 'N/A';  // Ensure empty values are shown as "N/A"
            return value;
        }
    },
    {
        id: 'feature',
        header: 'Feature',
        accessorKey: 'feature',
        size: 500, // Set a reasonable default width
        minSize: 400, // Prevent it from being too small
        maxSize: 600, // Prevent it from stretching too much
        enableSorting: false,
        cell: ({ getValue }) => {
            const features = getValue();
            return (
                <div style={{
                    display: 'block',
                    maxWidth: '100%',
                    whiteSpace: 'normal', // Allows wrapping
                    wordBreak: 'keep-all', // Keeps words together, prevents weird breaks
                    overflowWrap: 'break-word', // Ensures long words break properly
                    padding: '4px',
                }}>
                    {features.join(', ')}
                </div>
            );
        },
    },
    {
        id: 'Impedance',
        header: 'Impedance',
        accessorKey: 'Impedance',
        enableSorting: true,
        sortUndefined: 'last',
        cell: ({ getValue }) => {
            const value = getValue() || 'N/A';  // Ensure empty values are shown as "N/A"
            return value;
        }
    },
    {
        id: 'Lighting Type',
        header: 'Lighting Type',
        accessorKey: 'Lighting Type',
        enableSorting: true,
        sortUndefined: 'last',
        cell: ({ getValue }) => {
            const value = getValue() || 'N/A';  // Ensure empty values are shown as "N/A"
            return value;
        }
    },
    {
        id: 'Customizable Lighting',
        header: 'Customizable Lighting',
        accessorKey: 'Customizable Lighting',
        enableSorting: true,
        sortUndefined: 'last',
        cell: ({ getValue }) => {
            const value = getValue() || 'N/A';  // Ensure empty values are shown as "N/A"
            return value;
        }
    },
    {
        id: 'Number Of Devices Connectable Simultaneously',
        header: 'Number Of Devices Connectable Simultaneously',
        accessorKey: 'Number Of Devices Connectable Simultaneously',
        enableSorting: true,
        sortUndefined: 'last',
        cell: ({ getValue }) => {
            const value = getValue() || 'N/A';  // Ensure empty values are shown as "N/A"
            return value;
        }
    },
]

const data = [
    {
        "link": "https://www.bestbuy.com/site/steelseries-arctis-nova-pro-wireless-multi-gaming-headset-for-pc-ps5-ps4-switch-black/6506219.p?skuId=6506219",
        "name": "SteelSeries - Arctis Nova Pro Wireless Multi Gaming Headset for PC, PS5, PS4, Switch - Black",
        "model": "61520",
        "Noise Cancelling (Active)": "Yes",
        "Sound Mode": "Surround 7.1",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Radio Frequency (RF - 2.4 Ghz/Low Latency), Bluetooth",
        "Maximum Wireless Range": "30 feet",
        "Built-In Microphone": "Yes",
        "Carrying Case": "Yes",
        "Microphone Features": "Retractable, Noise cancelling",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "44 hours",
        "Battery Charge Time": "4 hours",
        "Compatible Platform(s)": "Windows, Mac, PlayStation 4, PlayStation 5, Nintendo Switch",
        "Product Name": "Arctis Nova Pro Wireless Multi Gaming Headset for PC, PS5, PS4, Switch",
        "Brand": "SteelSeries",
        "Model Number": "61520",
        "Color": "Black",
        "Sound Isolating": "Yes",
        "Environmental Noise Control": "Yes",
        "Minimum Frequency Response": "10 hertz",
        "Maximum Frequency Response": "22 kilohertz",
        "Sensitivity": "93 decibels adjusted",
        "Integrated Amplifier": "Yes",
        "Driver Size": "40 millimeters",
        "Bluetooth Version": "5.0",
        "Controls": "Volume, Mute",
        "Lighting Type": "None",
        "High Resolution Audio": "True",
        "Foldable Design": "Yes",
        "Fast Charging": "Yes",
        "On/Off Switch": "Yes",
        "feature": [
            "Worn By Champions",
            "Active Noise Cancellation",
            "Neodymium Magnetic Drivers",
            "Onboard Audio Profiles",
            "Unlimited Battery Life",
            "Multi-system Connect",
            "Simultaneous Bluetooth"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767499/headphone/xg47jgaqx5kuhjuuh0ax.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/steelseries-arctis-nova-7-wireless-gaming-headset-for-pc-ps5-and-ps4-black/6515802.p?skuId=6515802",
        "name": "SteelSeries - Arctis Nova 7 Wireless Gaming Headset for PC, PS5, and PS4 - Black",
        "model": "61553",
        "Noise Cancelling (Active)": "Yes",
        "Sound Mode": "Surround 7.1",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Radio Frequency (RF - 2.4 Ghz/Low Latency), Bluetooth",
        "Maximum Wireless Range": "30 feet",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Retractable, Adjustable, Noise cancelling",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "38 hours",
        "Battery Charge Time": "4 hours",
        "Compatible Platform(s)": "Mac/Windows, PlayStation 4, PlayStation 5, Nintendo Switch",
        "Product Name": "Arctis Nova 7 Wireless Gaming Headset for PC, PS5, and PS4",
        "Brand": "SteelSeries",
        "Model Number": "61553",
        "Color": "Black",
        "Sound Isolating": "Yes",
        "Minimum Frequency Response": "20 hertz",
        "Maximum Frequency Response": "22 kilohertz",
        "Sensitivity": "93 decibels adjusted",
        "Driver Size": "40 millimeters",
        "Controls": "Volume, Mute",
        "Lighting Type": "None",
        "Foldable Design": "Yes",
        "Fast Charging": "Yes",
        "On/Off Switch": "Yes",
        "feature": [
            "Neodymium Magnetic Drivers",
            "Dual Audio Streams",
            "Multi-Platform Wireless",
            "38-Hour Battery Life",
            "360° Spatial Audio",
            "X-Ray Hearing",
            "Ai Noise Cancelling"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767500/headphone/umixdvkite7bd9fd8dbx.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/steelseries-arctis-nova-pro-wireless-multi-gaming-headset-for-ps5-ps4-pc-switch-white/6576926.p?skuId=6576926",
        "name": "SteelSeries - Arctis Nova Pro Wireless Multi Gaming Headset for PS5, PS4, PC, Switch - White",
        "model": "61526",
        "Noise Cancelling (Active)": "Yes",
        "Sound Mode": "Surround 7.1",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Radio Frequency (RF - 2.4 Ghz/Low Latency), Bluetooth",
        "Maximum Wireless Range": "30 feet",
        "Built-In Microphone": "Yes",
        "Carrying Case": "Yes",
        "Microphone Features": "Retractable, Noise cancelling",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "44 hours",
        "Battery Charge Time": "4 hours",
        "Compatible Platform(s)": "Windows, Mac, PlayStation 4, PlayStation 5, Nintendo Switch",
        "Product Name": "Arctis Nova Pro Wireless Multi Gaming Headset for PS5, PS4, PC, Switch",
        "Brand": "SteelSeries",
        "Model Number": "61526",
        "Color": "White",
        "Sound Isolating": "Yes",
        "Environmental Noise Control": "Yes",
        "Minimum Frequency Response": "10 hertz",
        "Maximum Frequency Response": "22 kilohertz",
        "Sensitivity": "93 decibels adjusted",
        "Integrated Amplifier": "Yes",
        "Driver Size": "40 millimeters",
        "Bluetooth Version": "5.0",
        "Controls": "Volume, Mute",
        "Lighting Type": "None",
        "High Resolution Audio": "True",
        "Foldable Design": "Yes",
        "Fast Charging": "Yes",
        "On/Off Switch": "Yes",
        "feature": [
            "Worn By Champions",
            "Active Noise Cancellation",
            "Neodymium Magnetic Drivers",
            "Onboard Audio Profiles",
            "Unlimited Battery Life",
            "Multi-System Connect",
            "Simultaneous Bluetooth"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767501/headphone/vpq5vxenrggwhiwnhudk.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/razer-blackshark-v2-pro-2023-wireless-esports-gaming-headset-for-pc-ps5-ps4-switch-black/6538210.p?skuId=6538210",
        "name": "Razer - BlackShark V2 Pro (2023) Wireless Esports Gaming Headset for PC, PS5, PS4, Switch - Black",
        "model": "RZ04-04530100-R3U1",
        "Noise Cancelling (Active)": "No",
        "Sound Mode": "Stereo, Surround 7.1",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Radio Frequency (RF - 2.4 Ghz/Low Latency), Bluetooth",
        "Maximum Wireless Range": "10 feet",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Noise cancelling, Detachable",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "70 hours",
        "Compatible Platform(s)": "PlayStation, Android, iOS, Nintendo Switch",
        "Works With": "Cortana",
        "Product Name": "BlackShark V2 Pro (2023) Wireless Esports Gaming Headset for PC, PS5, PS4, Switch",
        "Brand": "Razer",
        "Model Number": "RZ04-04530100-R3U1",
        "Color": "Black",
        "Sound Isolating": "Yes",
        "Environmental Noise Control": "Yes",
        "Minimum Frequency Response": "12 hertz",
        "Maximum Frequency Response": "28 kilohertz",
        "Impedance": "32 ohms",
        "Sensitivity": "100 decibels adjusted",
        "Integrated Amplifier": "No",
        "Driver Size": "50 millimeters",
        "Bluetooth Version": "5.2",
        "Controls": "Volume, Mute",
        "Lighting Type": "None",
        "High Resolution Audio": "THX Spatial Audio",
        "Foldable Design": "No",
        "On/Off Switch": "Yes",
        "feature": [
            "Razer Hyperclear Super Wideband Mic",
            "Razer Triforce Titanium 50 Mm Drivers",
            "Razer Hyperspeed Wireless Technology",
            "Pro-Tuned Fps Audio Profiles",
            "Noise-Isolating Earcups With Ultra-Soft Memory Foam",
            "70 Hours Of Battery Life With Type C Charging"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767502/headphone/i4ti2aptqjtjwa2jqjqc.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/hyperx-cloud-iii-wired-gaming-headset-for-pc-ps5-ps4-xbox-series-xs-xbox-one-nintendo-switch-and-mobile-black/6542541.p?skuId=6542541",
        "name": "HyperX - Cloud III Wired Gaming Headset for PC, PS5, PS4, Xbox Series X|S, Xbox One, Nintendo Switch, and Mobile - Black",
        "model": "727A8AA",
        "Noise Cancelling (Active)": "Yes",
        "Sound Mode": "DTS Headphone:X",
        "Connection Type": "Wired",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Noise cancelling, Detachable",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Compatible Platform(s)": "Windows, PlayStation 5, Xbox Series X, Xbox Series S, Xbox One, Nintendo Switch, Android, iOS",
        "Product Name": "Cloud III Wired Gaming Headset for PC, PS5, PS4, Xbox Series X|S, Xbox One, Nintendo Switch, and Mobile",
        "Brand": "HyperX",
        "Model Number": "727A8AA",
        "Color": "Black",
        "Sound Isolating": "No",
        "Environmental Noise Control": "No",
        "Minimum Frequency Response": "10 hertz",
        "Maximum Frequency Response": "21 kilohertz",
        "Impedance": "64 ohms",
        "Sensitivity": "100 decibels adjusted",
        "Integrated Amplifier": "No",
        "Driver Size": "53 millimeters",
        "Connector Size": "1/8 in. (3.5mm)",
        "Detachable Cord": "Yes",
        "Controls": "Volume, Mute",
        "Lighting Type": "None",
        "High Resolution Audio": "No",
        "Foldable Design": "No",
        "feature": [
            "Comfort Is King",
            "Audio Tuned For Your Entertainment",
            "Upgraded Microphone For Clarity And Accuracy",
            "Durability, For The Toughest Of Battles",
            "Dts Headphone:X Spatial Audio",
            "Quick, Convenient Audio And Mic Controls",
            "Versatile Compatibility Via Usb-C, Usb-A, And 3.5mm"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767503/headphone/q1uye28y4ghybdqbmxia.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/razer-blackshark-v2-x-wired-gaming-headset-for-pc-ps5-ps4-switch-xbox-xs-and-xbox-one-black/6417114.p?skuId=6417114",
        "name": "Razer - BlackShark V2 X Wired Gaming Headset for PC, PS5, PS4, Switch, Xbox X|S, and Xbox One - Black",
        "model": "RZ04-03240100-R3U1",
        "Noise Cancelling (Active)": "No",
        "Sound Mode": "Stereo, Surround 7.1",
        "Connection Type": "Wired",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Noise cancelling, Detachable",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Compatible Platform(s)": "Mac/Windows, PlayStation 4, PlayStation 5, Nintendo Switch, Xbox Series X, Xbox Series S",
        "Works With": "Cortana",
        "Product Name": "BlackShark V2 X Wired Gaming Headset for PC, PS5, PS4, Switch, Xbox X|S, and Xbox One",
        "Brand": "Razer",
        "Model Number": "RZ04-03240100-R3U1",
        "Color": "Black",
        "Sound Isolating": "Yes",
        "Environmental Noise Control": "Yes",
        "Minimum Frequency Response": "12 hertz",
        "Maximum Frequency Response": "28 kilohertz",
        "Impedance": "32 ohms",
        "Sensitivity": "100 decibels adjusted",
        "Integrated Amplifier": "No",
        "Driver Size": "50 millimeters",
        "Connector Size": "1/8 in. (3.5mm)",
        "Detachable Cord": "No",
        "Controls": "Volume, Mute",
        "Lighting Type": "None",
        "High Resolution Audio": "7.1 Surround sound",
        "Foldable Design": "No",
        "feature": [
            "Razer Triforce 50mm Drivers For High-End Audio Performance",
            "Razer Hyperclear Cardioid Mic For Enhanced Voice Capture",
            "Advanced Passive Noise Cancellation For Uninterrupted Focus",
            "Lightweight Design With Memory Foam Ear Cushions For Long-Lasting Comfort",
            "7.1 Surround Sound For Accurate Positional Audio"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767503/headphone/drxefb6febyvuyjslxew.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/sony-inzone-h3-wired-gaming-headset-white/6510365.p?skuId=6510365",
        "name": "Sony - INZONE H3 Wired Gaming Headset - White",
        "model": "MDRG300/W",
        "Connection Type": "Wired",
        "Built-In Microphone": "Yes",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Compatible Platform(s)": "Windows, PlayStation 5",
        "Product Name": "INZONE H3 Wired Gaming Headset",
        "Brand": "Sony",
        "Model Number": "MDRG300/W",
        "Color": "White",
        "Sound Isolating": "No",
        "Environmental Noise Control": "Yes",
        "Connector Size": "1/8 in. (3.5mm), USB-C",
        "Lighting Type": "None",
        "feature": [
            "Personalized 360 Spatial Sound For Gaming Provides Precise Rival Detection",
            "Game For Hours In Comfort With Soft Headband And Smooth Ear Pads",
            "Discord Certified",
            "Clear Communications Via A Flexible Flip-Up Boom Microphone With Mute Function",
            "Ergonomically Designed Controls For Effortless Operation",
            "Personalize Your Experience Through The Inzone Hub Software",
            "For Playstation 5",
            "Elevate Gaming Experience With Inzone Gaming Monitors"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767504/headphone/ornn4wbmjcbahbblpgrf.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/razer-barracuda-x-2022-edition-wireless-gaming-headset-for-pc-ps5-ps4-switch-and-mobile-black/6502762.p?skuId=6502762",
        "name": "Razer - Barracuda X 2022 Edition Wireless Gaming Headset for PC, PS5, PS4, Switch, and Mobile - Black",
        "model": "RZ04-04430100-R3U1",
        "Noise Cancelling (Active)": "No",
        "Sound Mode": "Stereo, Surround 7.1",
        "Connection Type": "Wireless, Wired",
        "Wireless Connectivity": "Bluetooth, Radio Frequency (RF - 2.4 Ghz/Low Latency)",
        "Maximum Wireless Range": "10 feet",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Adjustable, Detachable, Noise cancelling",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "50 hours",
        "Compatible Platform(s)": "Mac/Windows, PlayStation 4, PlayStation 5, Nintendo Switch, Android",
        "Works With": "Cortana",
        "Product Name": "Barracuda X 2022 Edition Wireless Gaming Headset for PC, PS5, PS4, Switch, and Mobile",
        "Brand": "Razer",
        "Model Number": "RZ04-04430100-R3U1",
        "Color": "Black",
        "Sound Isolating": "No",
        "Environmental Noise Control": "Yes",
        "Minimum Frequency Response": "20 hertz",
        "Maximum Frequency Response": "20 kilohertz",
        "Impedance": "32 ohms",
        "Sensitivity": "96 decibels adjusted",
        "Integrated Amplifier": "No",
        "Driver Size": "40 millimeters",
        "Bluetooth Version": "5.2",
        "Connector Size": "1/8 in. (3.5mm), USB-C",
        "Detachable Cord": "Yes",
        "Controls": "Volume, Mute",
        "Lighting Type": "None",
        "High Resolution Audio": "7.1 Surround sound",
        "Foldable Design": "No",
        "On/Off Switch": "Yes",
        "feature": [
            "Razer Smartswitch Dual Wireless",
            "250g Ergonomic Design",
            "Razer Triforce 40mm Drivers",
            "Detachable Razer Hyperclear Cardioid Mic",
            "On-Headset Controls",
            "50 Hours Battery Life With Usb-C Charging"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767505/headphone/bbwugqeeci6jsehkf7sl.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/steelseries-arctis-nova-7-wireless-gaming-headset-for-pc-ps5-and-ps4-black/6515802.p?skuId=6515802",
        "name": "SteelSeries - Arctis Nova 7 Wireless Gaming Headset for PC, PS5, and PS4 - Black",
        "model": "61553",
        "Noise Cancelling (Active)": "Yes",
        "Sound Mode": "Surround 7.1",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Radio Frequency (RF - 2.4 Ghz/Low Latency), Bluetooth",
        "Maximum Wireless Range": "30 feet",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Retractable, Adjustable, Noise cancelling",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "38 hours",
        "Battery Charge Time": "4 hours",
        "Compatible Platform(s)": "Mac/Windows, PlayStation 4, PlayStation 5, Nintendo Switch",
        "Product Name": "Arctis Nova 7 Wireless Gaming Headset for PC, PS5, and PS4",
        "Brand": "SteelSeries",
        "Model Number": "61553",
        "Color": "Black",
        "Sound Isolating": "Yes",
        "Minimum Frequency Response": "20 hertz",
        "Maximum Frequency Response": "22 kilohertz",
        "Sensitivity": "93 decibels adjusted",
        "Driver Size": "40 millimeters",
        "Controls": "Volume, Mute",
        "Lighting Type": "None",
        "Foldable Design": "Yes",
        "Fast Charging": "Yes",
        "On/Off Switch": "Yes",
        "feature": [
            "Neodymium Magnetic Drivers",
            "Dual Audio Streams",
            "Multi-Platform Wireless",
            "38-Hour Battery Life",
            "360° Spatial Audio",
            "X-Ray Hearing",
            "Ai Noise Cancelling"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767506/headphone/p6tvhye42lb0ypmypnky.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/corsair-hs80-max-wireless-gaming-headset-for-pc-ps5-ps4-steel-gray/6551313.p?skuId=6551313",
        "name": "CORSAIR - HS80 MAX Wireless Gaming Headset for PC, PS5, PS4 - Steel Gray",
        "model": "CA-9011295-NA",
        "Noise Cancelling (Active)": "Yes",
        "Sound Mode": "Dolby Atmos",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Radio Frequency (RF), Bluetooth",
        "Maximum Wireless Range": "50 feet",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Noise cancelling",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "65 hours",
        "Battery Charge Time": "1.5 hours",
        "Compatible Platform(s)": "Mac/Windows, PlayStation 4, PlayStation 5",
        "Works With": "Cortana, Google Assistant, Siri",
        "Product Name": "HS80 MAX Wireless Gaming Headset for PC, PS5, PS4",
        "Brand": "CORSAIR",
        "Model Number": "CA-9011295-NA",
        "Color": "Gray",
        "Sound Isolating": "No",
        "Environmental Noise Control": "Yes",
        "Minimum Frequency Response": "100 hertz",
        "Maximum Frequency Response": "10 kilohertz",
        "Impedance": "2.2 ohms",
        "Driver Size": "50 millimeters",
        "Bluetooth Version": "5.2",
        "Controls": "Mute, Volume",
        "Customizable Lighting": "Yes",
        "Lighting Type": "RGB",
        "Foldable Design": "No",
        "On/Off Switch": "Yes",
        "feature": [
            "Low-Latency 2.4ghz Wireless Plus Bluetooth",
            "Multiplatform Compatibility For Pc, Mac, Ps5, Ps4, And Mobile",
            "Long-Lasting Battery Life",
            "Hours Of Long-Lasting Plush Comfort",
            "Dolby Atmos Spatial Audio On Pc",
            "Stunningly Detailed Sound",
            "Omni-Directional Microphone With Nvidia Broadcast",
            "Sonarworks Soundid Technology",
            "Powerful Corsair Icue Software"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767507/headphone/v8aosyg7r68sedvc86b2.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/turtle-beach-stealth-700-gen-3-wireless-multiplatform-amplified-gaming-headset-for-pc-ps5-ps4-mobile-with-80-hr-battery-black/6590340.p?skuId=6590340",
        "name": "Turtle Beach - Stealth™ 700 Gen 3 Wireless Multiplatform Amplified Gaming Headset for PC, PS5, PS4, & Mobile with 80-Hr Battery - Black",
        "model": "TBS-5102-05",
        "Sound Mode": "Stereo",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Radio Frequency (RF - 2.4 Ghz/Low Latency), Bluetooth",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Compatible Platform(s)": "Windows, PlayStation 5, PlayStation 4, Steam Deck",
        "Product Name": "Stealth™ 700 Gen 3 Wireless Multiplatform Amplified Gaming Headset for PC, PS5, PS4, & Mobile with 80-Hr Battery",
        "Brand": "Turtle Beach",
        "Model Number": "TBS-5102-05",
        "Color": "Black",
        "Sound Isolating": "Yes",
        "Driver Size": "60 millimeters",
        "Controls": "Volume",
        "Lighting Type": "None",
        "Foldable Design": "Yes",
        "On/Off Switch": "Yes",
        "feature": [
            "Crossplay Multiplatform Wireless Audio System",
            "Simultaneous Wireless + Bluetooth®",
            "24-Bit Resolution, High-Fidelity Wireless Audio",
            "Stunning Audio Clarity",
            "Waves 3d Audio For Pc",
            "Exceptional Broadcast Quality Microphone",
            "Unstoppable, 80-Hour Battery Life",
            "Superb Comfort, Unmatched Durability",
            "Anywhere Audio Customization",
            "Remappable Wheel & Mode Button",
            "Advanced Superhuman Hearing®",
            "Easy Access To Audio Presets",
            "Variable Mic Monitoring"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767508/headphone/zawgjhm1zg6lrkcixubc.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/steelseries-arctis-nova-1-wired-gaming-headset-for-pc-ps5-and-ps4-black/6515789.p?skuId=6515789",
        "name": "SteelSeries - Arctis Nova 1 Wired Gaming Headset for PC, PS5, and PS4 - Black",
        "model": "61606",
        "Noise Cancelling (Active)": "Yes",
        "Sound Mode": "Surround 7.1",
        "Connection Type": "Wired",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Retractable, Adjustable, Noise cancelling",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Compatible Platform(s)": "Mac/Windows, PlayStation 4, PlayStation 5, Xbox Series S, Xbox Series X, Xbox One, Nintendo Switch, Android, iOS",
        "Product Name": "Arctis Nova 1 Wired Gaming Headset for PC, PS5, and PS4",
        "Brand": "SteelSeries",
        "Model Number": "61606",
        "Color": "Black",
        "Sound Isolating": "Yes",
        "Minimum Frequency Response": "20 hertz",
        "Maximum Frequency Response": "22 kilohertz",
        "Sensitivity": "93 decibels adjusted",
        "Driver Size": "40 millimeters",
        "Connector Size": "1/8 in. (3.5mm)",
        "Detachable Cord": "Yes",
        "Controls": "Volume, Mute",
        "Lighting Type": "None",
        "Foldable Design": "Yes",
        "feature": [
            "Almighty Audio",
            "Multi-Platform Support",
            "Bidirectional Noise-Cancelling Stealth Mic",
            "Adjustable For Perfect Fit",
            "Easy Settings",
            "360° Spatial Audio"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767508/headphone/lsqqvav6zgcuw1crnzbq.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/hyperx-cloud-stinger-core-wireless-gaming-headset-for-pc-ps5-and-ps4-white/6431194.p?skuId=6431194",
        "name": "HyperX - Cloud Stinger Core Wireless Gaming Headset for PC, PS5, and PS4 - White",
        "model": "4P5J1AA/HHSS1C-KB-WT/G",
        "Noise Cancelling (Active)": "No",
        "Sound Mode": "Stereo",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Radio Frequency (RF)",
        "Maximum Wireless Range": "39.4 feet",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Noise cancelling, Adjustable",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "17 hours",
        "Battery Charge Time": "3 hours",
        "Compatible Platform(s)": "Windows, PlayStation 5, PlayStation 4",
        "Product Name": "Cloud Stinger Core Wireless Gaming Headset for PC, PS5, and PS4",
        "Brand": "HyperX",
        "Model Number": "4P5J1AA/HHSS1C-KB-WT/G",
        "Color": "White",
        "Sound Isolating": "No",
        "Environmental Noise Control": "No",
        "Minimum Frequency Response": "10 hertz",
        "Maximum Frequency Response": "21 kilohertz",
        "Impedance": "16 ohms",
        "Sensitivity": "-40 decibels adjusted",
        "Integrated Amplifier": "No",
        "Driver Size": "40 millimeters",
        "Controls": "Volume, Mute",
        "Lighting Type": "None",
        "High Resolution Audio": "No",
        "Foldable Design": "No",
        "On/Off Switch": "Yes",
        "feature": [
            "Gaming-Grade Wireless",
            "Lightweight Comfort",
            "Immersive In-Game Audio",
            "Adjust To Fit Comfortably, Durable Build Quality For Everyday Use",
            "Swivel-To-Mute Noise-Cancelling Mic",
            "Compatible With Ps5, Ps4, And Pc"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767509/headphone/roncoujuonb6p8knrwkf.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/hyperx-cloud-alpha-wireless-gaming-headset-for-pc-ps5-and-ps4-black-red/6499569.p?skuId=6499569",
        "name": "HyperX - Cloud Alpha Wireless Gaming Headset for PC, PS5, and PS4 - Black/Red",
        "model": "4P5D4AA",
        "Noise Cancelling (Active)": "No",
        "Sound Mode": "DTS Headphone:X",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Radio Frequency (RF - 2.4 Ghz/Low Latency)",
        "Maximum Wireless Range": "65.6 feet",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Noise cancelling, Detachable",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "300 hours",
        "Battery Charge Time": "4.5 hours",
        "Compatible Platform(s)": "Windows, PlayStation 5, PlayStation 4",
        "Product Name": "Cloud Alpha Wireless Gaming Headset for PC, PS5, and PS4",
        "Brand": "HyperX",
        "Model Number": "4P5D4AA",
        "Color": "Multi",
        "Sound Isolating": "No",
        "Environmental Noise Control": "No",
        "Minimum Frequency Response": "15 hertz",
        "Maximum Frequency Response": "21 kilohertz",
        "Impedance": "62 ohms",
        "Sensitivity": "103 decibels adjusted",
        "Integrated Amplifier": "No",
        "Driver Size": "50 millimeters",
        "Controls": "Mute, Volume",
        "Lighting Type": "None",
        "High Resolution Audio": "No",
        "Foldable Design": "No",
        "On/Off Switch": "Yes",
        "feature": [
            "Up To 300 Hours Of Battery Life²",
            "Dts Headphone:X⁴ Spatial Audio",
            "Hyperx Dual Chamber Drivers",
            "Signature Hyperx Comfort And Durability",
            "Durable Aluminum Frame",
            "Detachable Noise-Cancelling Mic With Led Status Indicator",
            "Onboard Audio Controls",
            "Compatible With Ngenuity Software",
            "Compatible Platforms"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767510/headphone/x1xc6w9sjamhftanmlyi.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/steelseries-arctis-pro-wireless-dts-headphonex-v2-0-surround-sound-gaming-headset-for-ps4-and-pc-black/6595755.p?skuId=6595755",
        "name": "SteelSeries - Arctis Pro Wireless DTS Headphone:X v2.0 Surround Sound Gaming Headset for PS4 and PC - Black",
        "model": "61478",
        "Noise Cancelling (Active)": "Yes",
        "Sound Mode": "Simulated Surround, Stereo",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Bluetooth, Radio Frequency (RF - 2.4 Ghz/Low Latency)",
        "Maximum Wireless Range": "40 feet",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Noise cancelling, Retractable",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "20 hours",
        "Battery Charge Time": "20 hours",
        "Compatible Platform(s)": "PlayStation 4, Windows",
        "Product Name": "Arctis Pro Wireless DTS Headphone:X v2.0 Surround Sound Gaming Headset for PS4 and PC",
        "Brand": "SteelSeries",
        "Model Number": "61478",
        "Color": "Black",
        "Sound Isolating": "Yes",
        "Environmental Noise Control": "Yes",
        "Minimum Frequency Response": "10 hertz",
        "Maximum Frequency Response": "40 kilohertz",
        "Impedance": "32 ohms",
        "Sensitivity": "102 decibels adjusted",
        "Driver Size": "40 millimeters",
        "Bluetooth Version": "5.0",
        "Number Of Devices Connectable Simultaneously": "2",
        "Controls": "Mute, Volume",
        "Lighting Type": "None",
        "Foldable Design": "No",
        "Fast Charging": "Yes",
        "On/Off Switch": "Yes",
        "feature": [
            "Dual-Wireless Technology",
            "Hi-Res Speaker Drivers",
            "Premium Materials",
            "Dual-Battery System",
            "The Best Mic In Gaming",
            "Dts Headphone:X V2.0 Surround",
            "Audio Command Center"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767511/headphone/qsikeqghbsxfxwtytnrh.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/astro-gaming-a10-gen-2-wired-gaming-headset-for-pc-gray/6498042.p?skuId=6498042",
        "name": "Astro Gaming - A10 Gen 2 Wired Gaming Headset for PC - Gray",
        "model": "939-002069",
        "Noise Cancelling (Active)": "No",
        "Sound Mode": "Dolby Atmos",
        "Connection Type": "Wired",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Adjustable, Retractable",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Compatible Platform(s)": "Windows, Mac, Xbox One, Xbox Series S, Xbox Series X, PlayStation 4, PlayStation 5",
        "Product Name": "A10 Gen 2 Wired Gaming Headset for PC",
        "Brand": "Astro Gaming",
        "Model Number": "939-002069",
        "Color": "Gray",
        "Sound Isolating": "Yes",
        "Environmental Noise Control": "No",
        "Minimum Frequency Response": "20 hertz",
        "Maximum Frequency Response": "20 kilohertz",
        "Impedance": "24 ohms",
        "Sensitivity": "102 decibels adjusted",
        "Driver Size": "32 millimeters",
        "Connector Size": "1/8 in. (3.5mm)",
        "Detachable Cord": "Yes",
        "Controls": "Volume",
        "Lighting Type": "None",
        "Foldable Design": "No",
        "feature": [
            "Enhanced Sound Quality",
            "Flip-To-Mute Mic",
            "In-Line Volume Control",
            "Built To Last",
            "Comfortable Over-Ear Headset",
            "Replaceable Ear Cushions And Headband Pad",
            "More Sustainable"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767512/headphone/xieytusmmitlwee5zb8d.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/hyperx-cloud-alpha-wired-gaming-headset-for-pc-xbox-xs-xbox-one-ps5-ps4-nintendo-switch-and-mobile-black-red/6100109.p?skuId=6100109",
        "name": "HyperX - Cloud Alpha Wired Gaming Headset for PC, Xbox X|S, Xbox One, PS5, PS4, Nintendo Switch, and Mobile - Black/Red",
        "model": "4P5L1AA#ABL/HX-HSCA-RD/AM",
        "Noise Cancelling (Active)": "No",
        "Sound Mode": "Stereo",
        "Connection Type": "Wired",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Noise cancelling, Detachable",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Compatible Platform(s)": "Windows, Xbox Series X, Xbox Series S, Xbox One, PlayStation 5, PlayStation 4, Nintendo Switch, Android, iOS",
        "Product Name": "Cloud Alpha Wired Gaming Headset for PC, Xbox X|S, Xbox One, PS5, PS4, Nintendo Switch, and Mobile",
        "Brand": "HyperX",
        "Model Number": "4P5L1AA#ABL/HX-HSCA-RD/AM",
        "Color": "Multi",
        "Sound Isolating": "No",
        "Environmental Noise Control": "No",
        "Minimum Frequency Response": "13 hertz",
        "Maximum Frequency Response": "27 kilohertz",
        "Impedance": "65 ohms",
        "Sensitivity": "98 decibels adjusted",
        "Integrated Amplifier": "No",
        "Driver Size": "50 millimeters",
        "Connector Size": "1/8 in. (3.5mm)",
        "Detachable Cord": "Yes",
        "Controls": "Volume",
        "Lighting Type": "None",
        "High Resolution Audio": "No",
        "Foldable Design": "No",
        "feature": [
            "Hyperx Dual Chamber Drivers",
            "Signature Hyperx Comfort",
            "Durable Aluminum Frame",
            "In-Line Audio Controls",
            "Detachable Noise-Cancelling Microphone",
            "Discord And Teamspeak Certified",
            "Multi-Platform Compatibility"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767513/headphone/imi2d6ysbbeear9ukp4r.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/corsair-virtuoso-xt-wireless-gaming-headset-for-pc-mac-ps5-ps4-and-mobile-slate/6458875.p?skuId=6458875",
        "name": "CORSAIR - VIRTUOSO XT Wireless Gaming Headset for PC, Mac, PS5, PS4, and Mobile - Slate",
        "model": "CA-9011188-NA",
        "Noise Cancelling (Active)": "No",
        "Sound Mode": "Dolby Atmos",
        "Connection Type": "Wireless, Wired",
        "Wireless Connectivity": "Bluetooth, Radio Frequency (RF)",
        "Maximum Wireless Range": "60 feet",
        "Built-In Microphone": "Yes",
        "Carrying Case": "Yes",
        "Microphone Features": "Detachable, Adjustable",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "15 hours",
        "Battery Charge Time": "2 hours",
        "Compatible Platform(s)": "Mac/Windows, Nintendo Switch, PlayStation 4, PlayStation 5, iOS",
        "Works With": "Cortana, Google Assistant, Siri",
        "Product Name": "VIRTUOSO XT Wireless Gaming Headset for PC, Mac, PS5, PS4, and Mobile",
        "Brand": "CORSAIR",
        "Model Number": "CA-9011188-NA",
        "Color": "Black",
        "Sound Isolating": "No",
        "Environmental Noise Control": "No",
        "Minimum Frequency Response": "20 hertz",
        "Maximum Frequency Response": "40 kilohertz",
        "Impedance": "32 ohms",
        "Sensitivity": "-42 decibels adjusted",
        "Integrated Amplifier": "No",
        "Driver Size": "50 millimeters",
        "Bluetooth Version": "5.0",
        "Number Of Devices Connectable Simultaneously": "2",
        "Connector Size": "USB-A, 1/8 in. (3.5mm)",
        "Detachable Cord": "Yes",
        "Controls": "Mute, Volume",
        "Customizable Lighting": "Yes",
        "Lighting Type": "RGB",
        "High Resolution Audio": "50mm high-density neodymium speaker drivers",
        "Foldable Design": "Yes",
        "On/Off Switch": "Yes",
        "feature": [
            "Simultaneous Dual-Wireless Connections",
            "Uncompromising Sound Quality",
            "Comfort Is King",
            "Broadcast-Grade Detachable Microphone",
            "Premium Lightweight Construction",
            "Immersive Dolby Atmos On Pc",
            "Wide Device Compatibility",
            "High-Fidelity 24bit/96khz Usb Audio",
            "Multi-Function Button",
            "Inline 3.5mm Controller",
            "All-Day, All-Night Battery Life",
            "Dynamic Rgb Lighting",
            "Intelligent Control, Unlimited Possibilities",
            "Storage Pouch Included"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767514/headphone/lom37nayma9afdtsxt2c.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/hyperx-cloud-stinger-core-wireless-gaming-headset-for-pc-ps5-and-ps4-white/6431194.p?skuId=6431194",
        "name": "HyperX - Cloud Stinger Core Wireless Gaming Headset for PC, PS5, and PS4 - White",
        "model": "4P5J1AA/HHSS1C-KB-WT/G",
        "Noise Cancelling (Active)": "No",
        "Sound Mode": "Stereo",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Radio Frequency (RF)",
        "Maximum Wireless Range": "39.4 feet",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Noise cancelling, Adjustable",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "17 hours",
        "Battery Charge Time": "3 hours",
        "Compatible Platform(s)": "Windows, PlayStation 5, PlayStation 4",
        "Product Name": "Cloud Stinger Core Wireless Gaming Headset for PC, PS5, and PS4",
        "Brand": "HyperX",
        "Model Number": "4P5J1AA/HHSS1C-KB-WT/G",
        "Color": "White",
        "Sound Isolating": "No",
        "Environmental Noise Control": "No",
        "Minimum Frequency Response": "10 hertz",
        "Maximum Frequency Response": "21 kilohertz",
        "Impedance": "16 ohms",
        "Sensitivity": "-40 decibels adjusted",
        "Integrated Amplifier": "No",
        "Driver Size": "40 millimeters",
        "Controls": "Volume, Mute",
        "Lighting Type": "None",
        "High Resolution Audio": "No",
        "Foldable Design": "No",
        "On/Off Switch": "Yes",
        "feature": [
            "Gaming-Grade Wireless",
            "Lightweight Comfort",
            "Immersive In-Game Audio",
            "Adjust To Fit Comfortably, Durable Build Quality For Everyday Use",
            "Swivel-To-Mute Noise-Cancelling Mic",
            "Compatible With Ps5, Ps4, And Pc"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767514/headphone/ooiesuf2oyck2agxunoq.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/logitech-g733-lightspeed-wireless-gaming-headset-for-ps4-pc-black/6420856.p?skuId=6420856",
        "name": "Logitech - G733 LIGHTSPEED Wireless Gaming Headset for PS4, PC - Black",
        "model": "981-000863",
        "Noise Cancelling (Active)": "No",
        "Sound Mode": "DTS Headphone:X",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Radio Frequency (RF)",
        "Maximum Wireless Range": "66 feet",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Detachable, Noise cancelling",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "29 hours",
        "Battery Charge Time": "3 hours",
        "Compatible Platform(s)": "Windows, Mac, PlayStation 4",
        "Product Name": "G733 LIGHTSPEED Wireless Gaming Headset for PS4, PC",
        "Brand": "Logitech",
        "Model Number": "981-000863",
        "Color": "Black",
        "Sound Isolating": "Yes",
        "Minimum Frequency Response": "20 hertz",
        "Maximum Frequency Response": "20 kilohertz",
        "Impedance": "39 ohms",
        "Sensitivity": "87.5 decibels adjusted",
        "Driver Size": "40 millimeters",
        "Controls": "Volume",
        "Customizable Lighting": "Yes",
        "Lighting Type": "RGB",
        "Foldable Design": "No",
        "On/Off Switch": "Yes",
        "feature": [
            "Immersive Sound",
            "Comfortable, Colorful Suspension Headband",
            "Rechargeable Battery",
            "Console Compatible Gaming Headset",
            "Advanced Mic Filters",
            "2.4ghz Lightspeed Wireless Headset",
            "Soft Dual-Layer Memory Foam",
            "Lightsync Rgb ~16.8m Colors",
            "More Sustainable"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767515/headphone/gkmfdblhaf0t5wcslla9.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/corsair-hs-series-hs55-wireless-gaming-headset-for-pc-ps5-and-mobile-carbon/6530825.p?skuId=6530825",
        "name": "CORSAIR - HS Series HS55 Wireless Gaming Headset for PC, PS5, and Mobile - Carbon",
        "model": "CA-9011280-NA",
        "Noise Cancelling (Active)": "Yes",
        "Sound Mode": "Dolby Atmos",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Radio Frequency (RF), Bluetooth",
        "Maximum Wireless Range": "50 feet",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Retractable, Flip to mute",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "24 hours",
        "Battery Charge Time": "1 hours",
        "Compatible Platform(s)": "Windows, Mac, PlayStation 5, PlayStation 4",
        "Works With": "Cortana, Google Assistant, Siri",
        "Product Name": "HS Series HS55 Wireless Gaming Headset for PC, PS5, and Mobile",
        "Brand": "CORSAIR",
        "Model Number": "CA-9011280-NA",
        "Color": "Black",
        "Sound Isolating": "No",
        "Environmental Noise Control": "No",
        "Minimum Frequency Response": "20 hertz",
        "Maximum Frequency Response": "20 kilohertz",
        "Impedance": "32 ohms",
        "Sensitivity": "114 decibels adjusted",
        "Driver Size": "50 millimeters",
        "Bluetooth Version": "5.0",
        "Controls": "Mute, Volume",
        "Lighting Type": "None",
        "Foldable Design": "No",
        "On/Off Switch": "Yes",
        "feature": [
            "Low-Latency 2.4ghz Wireless Or Bluetooth",
            "Lightweight Construction And All-Day Comfort",
            "Dolby  Audio 7.1 Surround Sound On Pc And Mac",
            "Great Gaming Audio",
            "Omni-Directional Microphone With Flip-To-Mute Function",
            "Easy-Access On-Ear Audio Controls",
            "Unite Your Setup"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767516/headphone/snpjq30exdwaec2jqxmk.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/astro-gaming-a50-gen-4-wireless-gaming-headset-for-xbox-one-xbox-series-xs-and-pc-black/6349970.p?skuId=6349970",
        "name": "Astro Gaming - A50 Gen 4 Wireless Gaming Headset for Xbox One, Xbox Series X|S, and PC - Black",
        "model": "939-001680",
        "Noise Cancelling (Active)": "No",
        "Sound Mode": "Dolby Atmos",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Radio Frequency (RF)",
        "Maximum Wireless Range": "30 feet",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Adjustable",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "15 hours",
        "Compatible Platform(s)": "Xbox One, Xbox Series S, Xbox Series X, Windows, Mac",
        "Product Name": "A50 Gen 4 Wireless Gaming Headset for Xbox One, Xbox Series X|S, and PC",
        "Brand": "Astro Gaming",
        "Model Number": "939-001680",
        "Color": "Black",
        "Sound Isolating": "Yes",
        "Environmental Noise Control": "No",
        "Minimum Frequency Response": "20 hertz",
        "Maximum Frequency Response": "20 kilohertz",
        "Impedance": "48 ohms",
        "Sensitivity": "118 decibels adjusted",
        "Driver Size": "40 millimeters",
        "Controls": "Mute, Volume",
        "Lighting Type": "None",
        "Foldable Design": "No",
        "feature": [
            "Astro Audio V2",
            "Dolby Audio",
            "Up To 15+ Hours Of Battery Life",
            "Compatibility",
            "Game:Voice Balance",
            "Astro Command Centre Software",
            "Usb Sound Card Functionality",
            "More Sustainable"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767517/headphone/hyfrteldurbhi9pnxgom.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/razer-kraken-v4-pro-wireless-gaming-headset-with-9-zone-chroma-rgb-for-pc-mac-ps5-nintendo-switch-steam-deck-smartphone-black/6589878.p?skuId=6589878",
        "name": "Razer - Kraken V4 Pro Wireless Gaming Headset with 9 Zone Chroma RGB - For PC, Mac, PS5, Nintendo Switch, Steam Deck, Smartphone - Black",
        "model": "RZ04-05160100-R3U1",
        "Sound Mode": "Surround 7.1",
        "Connection Type": "Wireless, Wired",
        "Wireless Connectivity": "Bluetooth, Radio Frequency (RF - 2.4 Ghz/Low Latency)",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Retractable",
        "Headphone Fit": "Over-the-Ear",
        "Battery Life": "50 hours",
        "Compatible Platform(s)": "Windows, Mac, PlayStation 5, Nintendo Switch, Steam Deck",
        "Product Name": "Kraken V4 Pro Wireless Gaming Headset with 9 Zone Chroma RGB - For PC, Mac, PS5, Nintendo Switch, Steam Deck, Smartphone",
        "Brand": "Razer",
        "Model Number": "RZ04-05160100-R3U1",
        "Color": "Black",
        "Sound Isolating": "Yes",
        "Minimum Frequency Response": "20 hertz",
        "Maximum Frequency Response": "28 kilohertz",
        "Impedance": "32 ohms",
        "Sensitivity": "98 decibels adjusted",
        "Integrated Amplifier": "Yes",
        "Bluetooth Version": "5.3",
        "Number Of Devices Connectable Simultaneously": "3",
        "Connector Size": "USB-C",
        "Detachable Cord": "Yes",
        "Controls": "Mute, Volume",
        "Customizable Lighting": "Yes",
        "Lighting Type": "RGB",
        "High Resolution Audio": "THX Spatial Audio",
        "feature": [
            "Oled Control Hub",
            "Razer Sensa Hd Haptics",
            "4 Modes Of Connectivity",
            "Retractable Razer Hyperclear Super Wideband Mic",
            "Razer Triforce Bio-Cellulose 40 Mm Drivers",
            "Thx Spatial Audio"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767518/headphone/bucq6uyid2csyrxxijvo.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/razer-barracuda-x-chroma-wireless-multi-platform-gaming-headset-with-6-zone-earcup-lighting-black/6599036.p?skuId=6599036",
        "name": "Razer - Barracuda X Chroma Wireless Multi-Platform Gaming Headset with 6 Zone Earcup Lighting - Black",
        "model": "RZ04-05220100-R3U1",
        "Sound Mode": "Surround 7.1, Stereo",
        "Connection Type": "Wireless, Wired",
        "Wireless Connectivity": "Radio Frequency (RF - 2.4 Ghz/Low Latency), Bluetooth",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Adjustable, Detachable, Noise cancelling",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "70 hours",
        "Compatible Platform(s)": "Mac/Windows, PlayStation 4, PlayStation 5, Android, Nintendo Switch",
        "Product Name": "Barracuda X Chroma Wireless Multi-Platform Gaming Headset with 6 Zone Earcup Lighting",
        "Brand": "Razer",
        "Model Number": "RZ04-05220100-R3U1",
        "Color": "Black",
        "Sound Isolating": "No",
        "Minimum Frequency Response": "20 hertz",
        "Maximum Frequency Response": "20 kilohertz",
        "Impedance": "32 ohms",
        "Sensitivity": "96 decibels adjusted",
        "Integrated Amplifier": "No",
        "Driver Size": "40 millimeters",
        "Bluetooth Version": "5.3",
        "Connector Size": "USB-C, 1/8 in. (3.5mm)",
        "Detachable Cord": "Yes",
        "Controls": "Volume, Mute",
        "Customizable Lighting": "Yes",
        "Lighting Type": "RGB",
        "High Resolution Audio": "7.1 Surround sound",
        "Foldable Design": "No",
        "On/Off Switch": "Yes",
        "feature": [
            "Razer Smartswitch Dual Wireless To Quick-Toggle Between Razer Hyperspeed And Bluetooth",
            "6-Zone Earcup Lighting Powered By Razer Chroma Rgb",
            "285g Ergonomic Design For All-Day Comfort Both Indoors And Out",
            "Razer Triforce 40 Mm Drivers For High-End Audio Performance",
            "70-Hour Battery Life With Type C Charging For All-Day Use",
            "Detachable Razer Hyperclear Cardioid Mic For Crystal-Clear Voice Capture"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767518/headphone/tahlzhaoweu5qhuihn4m.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/turtle-beach-recon-50x-wired-gaming-headset-for-xbox-series-x--s-xbox-one-ps5-ps4-playstation-nintendo-switch-mobile-pc-black-green/9539004.p?skuId=9539004",
        "name": "Turtle Beach - Recon 50X Wired Gaming Headset for Xbox Series X | S, Xbox One, PS5, PS4, PlayStation, Nintendo Switch, Mobile & PC - Black/Green",
        "model": "TBS-2303-05",
        "Sound Mode": "Stereo",
        "Connection Type": "Wired",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Adjustable, Detachable",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Compatible Platform(s)": "Xbox Series X, Xbox One, PlayStation 5, PlayStation 4, Nintendo Switch, Nintendo Switch Lite, Nintendo Switch – OLED Model, Xbox Series S",
        "Product Name": "Recon 50X Wired Gaming Headset for Xbox Series X | S, Xbox One, PS5, PS4, PlayStation, Nintendo Switch, Mobile & PC",
        "Brand": "Turtle Beach",
        "Model Number": "TBS-2303-05",
        "Color": "Black",
        "Sound Isolating": "Yes",
        "Minimum Frequency Response": "20 hertz",
        "Maximum Frequency Response": "20 kilohertz",
        "Impedance": "32 ohms",
        "Integrated Amplifier": "No",
        "Driver Size": "40 millimeters",
        "Connector Size": "1/8 in. (3.5mm)",
        "Detachable Cord": "No",
        "Controls": "Mute, Volume",
        "Lighting Type": "None",
        "Foldable Design": "Yes",
        "feature": [
            "Works With Xbox Series X|S",
            "Lightweight & Comfortable Design",
            "Surround Sound Ready For Xbox",
            "High-Quality 40mm Speakers",
            "Convenient In-Line Controls",
            "Crystal Clear Chat",
            "Versatile Compatibility"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767519/headphone/zwifqxtfokmuvunlcnrz.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/logitech-astro-a50-x-lightspeed-wireless-with-playsync-gaming-headset-base-station-for-xbox-series-xs-ps5-pc-mac-black/6572603.p?skuId=6572603",
        "name": "Logitech - Astro A50 X LIGHTSPEED Wireless with PLAYSYNC Gaming Headset + Base Station for Xbox Series X|S,  PS5, PC/MAC - Black",
        "model": "939-002126",
        "Sound Mode": "Dolby Atmos, Other",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Bluetooth, Radio Frequency (RF - 2.4 Ghz/Low Latency)",
        "Maximum Wireless Range": "39.37 feet",
        "Built-In Microphone": "Yes",
        "Microphone Features": "Flip to mute",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "24 hours",
        "Compatible Platform(s)": "Windows, Mac, Xbox Series S, Xbox Series X, Xbox One, PlayStation 5, PlayStation 4",
        "Product Name": "Astro A50 X LIGHTSPEED Wireless with PLAYSYNC Gaming Headset + Base Station for Xbox Series X|S,  PS5, PC/MAC",
        "Brand": "Logitech",
        "Model Number": "939-002126",
        "Color": "Black",
        "Sound Isolating": "Yes",
        "Minimum Frequency Response": "20 hertz",
        "Maximum Frequency Response": "20 kilohertz",
        "Driver Size": "40 millimeters",
        "Foldable Design": "No",
        "On/Off Switch": "Yes",
        "feature": [
            "Pro-G Graphene Audio Drivers",
            "24-Hours Of Playtime (At 78 Db)",
            "Playsync Simultaneous Multi-System",
            "Broadcast-Quality Mic",
            "Pro-Grade Lightspeed Wireless",
            "State-Of-The-Art Hdmi 2.1 Passthru",
            "Wireless Dual-Device Mixing",
            "Advanced G Hub And Mobile App Control"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767520/headphone/zo3kjxcjceokyhbaz0v6.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/astro-gaming-a20-gen-2-wireless-gaming-headset-for-xbox-one-xbox-series-xs-pc-white-green/6423471.p?skuId=6423471",
        "name": "Astro Gaming - A20 Gen 2 Wireless Gaming Headset for Xbox One, Xbox Series X|S, PC - White/Green",
        "model": "939-001882",
        "Noise Cancelling (Active)": "No",
        "Sound Mode": "Dolby Atmos",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Radio Frequency (RF)",
        "Maximum Wireless Range": "50 feet",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Retractable",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "15 hours",
        "Battery Charge Time": "3.5 hours",
        "Compatible Platform(s)": "Mac/Windows, Xbox One, Xbox Series X, Xbox Series S",
        "Product Name": "A20 Gen 2 Wireless Gaming Headset for Xbox One, Xbox Series X|S, PC",
        "Brand": "Astro Gaming",
        "Model Number": "939-001882",
        "Color": "White",
        "Sound Isolating": "Yes",
        "Environmental Noise Control": "No",
        "Minimum Frequency Response": "20 hertz",
        "Maximum Frequency Response": "20 kilohertz",
        "Impedance": "32 ohms",
        "Sensitivity": "100 decibels adjusted",
        "Driver Size": "40 millimeters",
        "Controls": "Mute, Volume",
        "Lighting Type": "None",
        "Foldable Design": "No",
        "On/Off Switch": "Yes",
        "feature": [
            "Up To 50ft Wireless Range",
            "Eq Presets",
            "Up To 15+ Hours Battery Life",
            "Compatible With Xbox Series X|S And Xbox One Gaming Consoles",
            "Flip-To-Mute Microphone",
            "Game:Voice Balance",
            "More Sustainable"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767521/headphone/conqsawsz5rrndgq07sh.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/turtle-beach-stealth-500-wireless-amplified-gaming-headset-for-ps5-ps4-pc-nintendo-switch-mobile-with-40-hr-battery-black/6577935.p?skuId=6577935",
        "name": "Turtle Beach - Stealth™ 500 Wireless Amplified Gaming Headset for PS5, PS4, PC, Nintendo Switch, & Mobile with 40-Hr Battery - Black",
        "model": "TBS-3103-05",
        "Sound Mode": "Stereo",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Radio Frequency (RF - 2.4 Ghz/Low Latency), Bluetooth",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Adjustable, Flip to mute, Noise cancelling",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "40 hours",
        "Compatible Platform(s)": "PlayStation 5, PlayStation 4, Nintendo Switch – OLED Model, Nintendo Switch, Steam Deck, iOS, Android",
        "Product Name": "Stealth™ 500 Wireless Amplified Gaming Headset for PS5, PS4, PC, Nintendo Switch, & Mobile with 40-Hr Battery",
        "Brand": "Turtle Beach",
        "Model Number": "TBS-3103-05",
        "Color": "Black",
        "Sound Isolating": "Yes",
        "Driver Size": "40 millimeters",
        "Controls": "Volume",
        "Lighting Type": "None",
        "Foldable Design": "Yes",
        "On/Off Switch": "Yes",
        "feature": [
            "Step Up To Wireless Freedom",
            "Best-In-Class Battery Life",
            "Quickswitch Technology",
            "Non-Stop Comfort",
            "Precise, Amplified Audio",
            "Anywhere Audio Customization",
            "Ultra-Clear, Flip-To-Mute Mic",
            "Easy Access To Audio Presets",
            "Advanced Superhuman Hearing®",
            "Variable Mic Monitoring"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767522/headphone/nchfki96gczt0tedmml9.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/sony-inzone-buds-truly-wireless-noise-canceling-gaming-earbuds-for-pc-and-ps5-black/6562123.p?skuId=6562123",
        "name": "Sony - INZONE Buds Truly Wireless Noise Canceling Gaming Earbuds for PC and PS5 - Black",
        "model": "WFG700N/B",
        "Noise Cancelling (Active)": "Yes",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Radio Frequency (RF - 2.4 Ghz/Low Latency)",
        "Maximum Wireless Range": "30 feet",
        "Built-In Microphone": "Yes",
        "Carrying Case": "Yes",
        "Microphone Features": "Fixed, Noise cancelling",
        "Headphone Fit": "In-Ear",
        "Battery Life": "24 hours",
        "Battery Charge Time": "2 hours",
        "Compatible Platform(s)": "Android, PlayStation, Windows",
        "Product Name": "INZONE Buds Truly Wireless Noise Canceling Gaming Earbuds for PC and PS5",
        "Brand": "Sony",
        "Model Number": "WFG700N/B",
        "Color": "Black",
        "Sound Isolating": "No",
        "Driver Size": "8.4 millimeters",
        "Controls": "Volume, Mute",
        "feature": [
            "Superior Sound Helps You Stay On Top",
            "Battery Life, 12-Hours Goes The Distance",
            "Increased Comfort. More Gaming",
            "Ai Helps You Be Heard In The Action",
            "A Truly Wireless Experience",
            "Low Latency Allows Enhanced Precision",
            "Customizable Controls",
            "Battery Life, 12-Hours With 2.4ghz Connection Goes The Distance"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767523/headphone/yishjewcg1x75zasq7fl.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/razer-kraken-kitty-edition-v2-pro-wired-gaming-headset-quartz-pink/6538905.p?skuId=6538905",
        "name": "Razer - Kraken Kitty Edition V2 Pro Wired Gaming Headset - Quartz Pink",
        "model": "RZ04-04510200-R3U1",
        "Noise Cancelling (Active)": "Yes",
        "Sound Mode": "Stereo, Surround 7.1",
        "Connection Type": "Wired",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Detachable, Noise cancelling",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Compatible Platform(s)": "Windows, Mac, PlayStation",
        "Works With": "Cortana",
        "Product Name": "Kraken Kitty Edition V2 Pro Wired Gaming Headset",
        "Brand": "Razer",
        "Model Number": "RZ04-04510200-R3U1",
        "Color": "Pink",
        "Sound Isolating": "Yes",
        "Environmental Noise Control": "Yes",
        "Minimum Frequency Response": "20 hertz",
        "Maximum Frequency Response": "20 kilohertz",
        "Impedance": "32 ohms",
        "Sensitivity": "96 decibels adjusted",
        "Integrated Amplifier": "No",
        "Driver Size": "50 millimeters",
        "Connector Size": "USB-A",
        "Detachable Cord": "No",
        "Controls": "Mute, Volume",
        "Customizable Lighting": "Yes",
        "Lighting Type": "RGB",
        "High Resolution Audio": "THX Spatial Audio",
        "Foldable Design": "No",
        "feature": [
            "Interchangeable Kitty, Bear, And Bunny Ears",
            "Stream Reactive Lighting",
            "Detachable Razer Hyperclear Cardioid Mic",
            "Razer Triforce Titanium 50mm Drivers",
            "7.1 Surround Sound",
            "Hybrid Fabric And Leatherette Cushions"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767524/headphone/xbae6zctbwb3idjeezpz.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/sony-inzone-h9-wireless-noise-canceling-gaming-headset-white/6510363.p?skuId=6510363",
        "name": "Sony - INZONE H9 Wireless Noise Canceling Gaming Headset - White",
        "model": "WHG900N/W",
        "Noise Cancelling (Active)": "Yes",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Bluetooth",
        "Maximum Wireless Range": "30 feet",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Flip to mute, Noise cancelling, Adjustable",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "32 hours",
        "Compatible Platform(s)": "Windows, PlayStation 5",
        "Product Name": "INZONE H9 Wireless Noise Canceling Gaming Headset",
        "Brand": "Sony",
        "Model Number": "WHG900N/W",
        "Color": "White",
        "Sound Isolating": "Yes",
        "Environmental Noise Control": "Yes",
        "Integrated Amplifier": "No",
        "Bluetooth Version": "5.0",
        "Lighting Type": "None",
        "Foldable Design": "Yes",
        "On/Off Switch": "Yes",
        "feature": [
            "Personalized 360 Spatial Sound For Gaming Provides Precise Rival Detection",
            "Dual Noise Sensor Technology Shuts Out Surrounding Sounds / Ambient Sound Mode Keeps You Aware Of Important Sounds",
            "Soft Headband Cushion And Synthetic Leather Ear Pads For Wearing Comfort",
            "Discord Certified",
            "Clear Communications Via A Flexible Flip-Up Boom Microphone With Mute Function",
            "Game Freely With Wireless Connectivity And Low Delay",
            "Up To 32 Hours Of Continuous Gameplay From A Single Charge",
            "Perfect For Playstation 5",
            "Ergonomically Designed Controls For Effortless Operation",
            "Ambient Sound Mode Keeps You Aware Of Important Sounds",
            "Personalize Your Experience Through The Inzone Hub Software",
            "Elevate Your Gaming Experience With Sony’S Inzone Gaming Monitors",
            "Simultaneous 2.4ghz And Bluetooth Connection"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767525/headphone/nrqqg7xt3qacqhovss7d.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/turtle-beach-stealth-500-wireless-amplified-gaming-headset-for-xbox-series-xs-xbox-one-mobile-with-40-hr-battery-black/6577936.p?skuId=6577936",
        "name": "Turtle Beach - Stealth™ 500 Wireless Amplified Gaming Headset for Xbox Series X|S, Xbox One, & Mobile with 40-Hr Battery - Black",
        "model": "TBS-2103-05",
        "Sound Mode": "Stereo",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Radio Frequency (RF - 2.4 Ghz/Low Latency), Bluetooth",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Adjustable, Flip to mute, Noise cancelling",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "40 hours",
        "Compatible Platform(s)": "Xbox Series X, Xbox Series S, Xbox One, Nintendo Switch – OLED Model, Nintendo Switch, Steam Deck, iOS, Android",
        "Product Name": "Stealth™ 500 Wireless Amplified Gaming Headset for Xbox Series X|S, Xbox One, & Mobile with 40-Hr Battery",
        "Brand": "Turtle Beach",
        "Model Number": "TBS-2103-05",
        "Color": "Black",
        "Sound Isolating": "Yes",
        "Driver Size": "40 millimeters",
        "Controls": "Volume",
        "Lighting Type": "None",
        "Foldable Design": "Yes",
        "On/Off Switch": "Yes",
        "feature": [
            "Step Up To Wireless Freedom",
            "Quickswitch Technology",
            "Best-In-Class Battery Life",
            "Precise, Amplified Audio",
            "Anywhere Audio Customization",
            "Ultra-Clear, Flip-To-Mute Mic",
            "Advanced Superhuman Hearing",
            "Easy Access To Audio Presets",
            "Variable Mic Monitoring",
            "Non-Stop Comfort"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767526/headphone/ezzxue46ozy7sdh0to7g.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/turtle-beach-stealth-500-wireless-amplified-gaming-headset-for-pc-ps5-ps4-nintendo-switch-mobile-with-40-hr-battery-black/6579296.p?skuId=6579296",
        "name": "Turtle Beach - Stealth™ 500 Wireless Amplified Gaming Headset for PC, PS5, PS4, Nintendo Switch, & Mobile with 40-Hr Battery - Black",
        "model": "TBS-5104-05",
        "Noise Cancelling (Active)": "No",
        "Sound Mode": "Stereo",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Radio Frequency (RF - 2.4 Ghz/Low Latency), Bluetooth",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Adjustable, Flip to mute, Noise cancelling",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "40 hours",
        "Battery Charge Time": "3 hours",
        "Compatible Platform(s)": "Windows, Nintendo Switch – OLED Model, Nintendo Switch, Steam Deck, iOS, Android, PlayStation 5, PlayStation 4",
        "Product Name": "Stealth™ 500 Wireless Amplified Gaming Headset for PC, PS5, PS4, Nintendo Switch, & Mobile with 40-Hr Battery",
        "Brand": "Turtle Beach",
        "Model Number": "TBS-5104-05",
        "Color": "Black",
        "Sound Isolating": "Yes",
        "Driver Size": "40 millimeters",
        "Controls": "Volume",
        "Lighting Type": "None",
        "Foldable Design": "Yes",
        "On/Off Switch": "Yes",
        "feature": [
            "Step Up To Wireless Freedom",
            "Best-In-Class Battery Life",
            "Quickswitch Technology",
            "Non-Stop Comfort",
            "Precise, Amplified Audio",
            "Anywhere Audio Customization",
            "Ultra-Clear, Flip-To-Mute Mic",
            "Easy Access To Audio Presets",
            "Advanced Superhuman Hearing®",
            "Variable Mic Monitoring"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767527/headphone/i8icg1gyo0zs94wxjx0p.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/logitech-a50-lightspeed-wireless-gaming-headset-base-station-gen-5-for-xbox-playstation-5-pc-mac-or-nintendo-switch-black/6595014.p?skuId=6595014",
        "name": "Logitech - A50 LIGHTSPEED Wireless Gaming Headset + Base Station (Gen 5) for Xbox, PlayStation 5, PC/Mac or Nintendo Switch - Black",
        "model": "939-002217",
        "Sound Mode": "Dolby Atmos",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Radio Frequency (RF - 2.4 Ghz/Low Latency), Bluetooth",
        "Maximum Wireless Range": "39 feet",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Flip to mute",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "24 hours",
        "Compatible Platform(s)": "Windows, Xbox Series S, Xbox Series X, Xbox One, PlayStation 5, PlayStation 4, Nintendo Switch",
        "Product Name": "A50 LIGHTSPEED Wireless Gaming Headset + Base Station (Gen 5) for Xbox, PlayStation 5, PC/Mac or Nintendo Switch",
        "Brand": "Logitech",
        "Model Number": "939-002217",
        "Color": "Black",
        "Sound Isolating": "Yes",
        "Minimum Frequency Response": "20 hertz",
        "Maximum Frequency Response": "20 kilohertz",
        "Sensitivity": "78 decibels adjusted",
        "Driver Size": "40 millimeters",
        "Controls": "Volume",
        "Lighting Type": "None",
        "On/Off Switch": "Yes",
        "feature": [
            "Playsync Audio 3-System Switching",
            "Pro-G Graphene Audio Drivers",
            "24-Bit Lightspeed Wireless",
            "Broadcast-Quality Mic",
            "Bluetooth Dual-Device Mixing",
            "24 Hours Of Playtime (At 78 Db)",
            "7-Core Dsp",
            "Advanced G Hub And G App Control"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767528/headphone/hoyuns07hhihoouxnfjb.jpg"
    },
    {
        "link": "https://www.bestbuy.com/site/astro-gaming-a20-gen-2-wireless-gaming-headset-for-ps5-ps4-pc-white-blue/6423475.p?skuId=6423475",
        "name": "Astro Gaming - A20 Gen 2 Wireless Gaming Headset for PS5, PS4, PC - White/Blue",
        "model": "939-001876",
        "Noise Cancelling (Active)": "No",
        "Sound Mode": "Dolby Atmos",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Radio Frequency (RF)",
        "Maximum Wireless Range": "50 feet",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Retractable",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "15 hours",
        "Battery Charge Time": "3.5 hours",
        "Compatible Platform(s)": "Mac/Windows, PlayStation 4, PlayStation 5",
        "Product Name": "A20 Gen 2 Wireless Gaming Headset for PS5, PS4, PC",
        "Brand": "Astro Gaming",
        "Model Number": "939-001876",
        "Color": "White",
        "Sound Isolating": "Yes",
        "Environmental Noise Control": "No",
        "Minimum Frequency Response": "20 hertz",
        "Maximum Frequency Response": "20 kilohertz",
        "Impedance": "32 ohms",
        "Sensitivity": "100 decibels adjusted",
        "Driver Size": "40 millimeters",
        "Controls": "Mute",
        "Lighting Type": "None",
        "Foldable Design": "No",
        "feature": [
            "Up To 50 Ft Wireless Range",
            "Cross-Platform Connectivity",
            "Up To 15+ Hours Battery Life",
            "Flip-To-Mute Microphone",
            "Eq Presets",
            "More Sustainable"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767529/headphone/umdthgirq0qftaaxgutq.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/razer-blackshark-v2-hyperspeed-wireless-gaming-headset-white/6573617.p?skuId=6573617",
        "name": "Razer - Blackshark V2 Hyperspeed Wireless Gaming Headset - White",
        "model": "RZ04-04960200-R3U1",
        "Noise Cancelling (Active)": "No",
        "Sound Mode": "Stereo",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Radio Frequency (RF - 2.4 Ghz/Low Latency), Bluetooth",
        "Maximum Wireless Range": "10 feet",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Detachable, Noise cancelling",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "70 hours",
        "Compatible Platform(s)": "Mac/Windows, PlayStation 4, PlayStation 5, Nintendo Switch",
        "Works With": "Cortana",
        "Product Name": "Blackshark V2 Hyperspeed Wireless Gaming Headset",
        "Brand": "Razer",
        "Model Number": "RZ04-04960200-R3U1",
        "Color": "White",
        "Sound Isolating": "Yes",
        "Environmental Noise Control": "Yes",
        "Minimum Frequency Response": "12 hertz",
        "Maximum Frequency Response": "28 kilohertz",
        "Impedance": "32 ohms",
        "Sensitivity": "100 decibels adjusted",
        "Integrated Amplifier": "No",
        "Driver Size": "50 millimeters",
        "Bluetooth Version": "5.2",
        "Controls": "Mute, Volume",
        "Lighting Type": "None",
        "High Resolution Audio": "THX Spatial Audio",
        "Foldable Design": "No",
        "On/Off Switch": "Yes",
        "feature": [
            "280g Ultra-Lightweight Design",
            "Razer Hyperclear Super Wideband Mic",
            "Razer Triforce Titanium 50 Mm Drivers",
            "Razer Hyperspeed Wireless Technology",
            "Noise-Isolating Earcups With Ultra-Soft Memory Foam",
            "70 Hours Of Battery Life With Type C Charging"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767530/headphone/cshnwectkvzxzekfn5sf.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/logitech-pro-x-2-lightspeed-wireless-gaming-headset-for-pc-ps5-ps4-nintendo-switch-black/6544740.p?skuId=6544740",
        "name": "Logitech - PRO X 2 LIGHTSPEED Wireless Gaming Headset for PC, PS5, PS4,  Nintendo Switch - Black",
        "model": "981-001262",
        "Noise Cancelling (Active)": "No",
        "Sound Mode": "Surround 7.1, DTS Headphone:X 2.0",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Radio Frequency (RF), Bluetooth",
        "Maximum Wireless Range": "98 feet",
        "Built-In Microphone": "Yes",
        "Carrying Case": "Yes",
        "Microphone Features": "Detachable",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "50 hours",
        "Compatible Platform(s)": "Windows, Nintendo Switch, PlayStation 5, PlayStation 4",
        "Product Name": "PRO X 2 LIGHTSPEED Wireless Gaming Headset for PC, PS5, PS4,  Nintendo Switch",
        "Brand": "Logitech",
        "Model Number": "981-001262",
        "Color": "Black",
        "Sound Isolating": "Yes",
        "Minimum Frequency Response": "20 hertz",
        "Maximum Frequency Response": "20 kilohertz",
        "Impedance": "38 ohms",
        "Sensitivity": "87.8 decibels adjusted",
        "Driver Size": "50 millimeters",
        "Number Of Devices Connectable Simultaneously": "1",
        "Controls": "Volume",
        "Foldable Design": "No",
        "On/Off Switch": "Yes",
        "feature": [
            "Clear Audio",
            "Pro Gaming Headset",
            "Long Battery Life And Range",
            "Console Compatible",
            "Clear Communication",
            "Connectivity",
            "Comfortable",
            "Surround Sound"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767531/headphone/mq4fwasbqkqz3z8h9ydk.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/turtle-beach-recon-70-multiplatform-wired-gaming-headset-for-pc-ps5-ps4-xbox-series-xs-xbox-one-nintendo-switch-mobile-black/6579303.p?skuId=6579303",
        "name": "Turtle Beach - Recon 70 Multiplatform Wired Gaming Headset for PC, PS5, PS4, Xbox Series X|S, Xbox One, Nintendo Switch & Mobile - Black",
        "model": "TBS-5001-05",
        "Connection Type": "Wired",
        "Carrying Case": "No",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Compatible Platform(s)": "Xbox Series X, Xbox Series S, Xbox One, PlayStation 5, PlayStation 4, Nintendo Switch – OLED Model, Nintendo Switch, iOS, Android, Windows",
        "Product Name": "Recon 70 Multiplatform Wired Gaming Headset for PC, PS5, PS4, Xbox Series X|S, Xbox One, Nintendo Switch & Mobile",
        "Brand": "Turtle Beach",
        "Model Number": "TBS-5001-05",
        "Color": "Black",
        "Sound Isolating": "Yes",
        "Driver Size": "40 millimeters",
        "Connector Size": "1/8 in. (3.5mm)",
        "Controls": "Volume",
        "Lighting Type": "None",
        "Foldable Design": "Yes",
        "feature": [
            "Lightweight Comfort",
            "High Sensitivity, Flip-To-Mute Mic",
            "Surround Sound Ready",
            "High-Quality 40mm Speakers",
            "Premium Ear Cushions",
            "Pc And Multiplatform Compatibility"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767532/headphone/fubvt9jjawudryzlvekj.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/corsair-virtuoso-max-wireless-gaming-headset-for-pc-mac-ps5-ps4-and-mobile-carbon/6594136.p?skuId=6594136",
        "name": "CORSAIR - VIRTUOSO MAX Wireless Gaming Headset for PC, Mac, PS5, PS4, and Mobile - Carbon",
        "model": "CA-9011372-WW",
        "Noise Cancelling (Active)": "Yes",
        "Sound Mode": "Dolby Atmos",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Bluetooth, Radio Frequency (RF - 2.4 Ghz/Low Latency)",
        "Maximum Wireless Range": "50 feet",
        "Built-In Microphone": "Yes",
        "Carrying Case": "Yes",
        "Microphone Features": "Detachable, Adjustable",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "60 hours",
        "Battery Charge Time": "1.5 hours",
        "Compatible Platform(s)": "Mac/Windows, PlayStation 5, PlayStation 4, Nintendo Switch, iOS",
        "Works With": "Cortana, Google Assistant, Siri",
        "Product Name": "VIRTUOSO MAX Wireless Gaming Headset for PC, Mac, PS5, PS4, and Mobile",
        "Brand": "CORSAIR",
        "Model Number": "CA-9011372-WW",
        "Color": "Black",
        "Sound Isolating": "No",
        "Environmental Noise Control": "Yes",
        "Minimum Frequency Response": "20 hertz",
        "Maximum Frequency Response": "40 kilohertz",
        "Impedance": "32 ohms",
        "Sensitivity": "-38 decibels adjusted",
        "Driver Size": "50 millimeters",
        "Bluetooth Version": "5.3",
        "Customizable Lighting": "Yes",
        "Lighting Type": "RGB",
        "Foldable Design": "No",
        "On/Off Switch": "Yes",
        "feature": [
            "Sounds So Good. Sounds Like Virtuoso Max",
            "Immersive Dolby Atmos Spatial Audio On Pc",
            "Sonarworks Soundid Technology",
            "Omni-Directional Microphone",
            "Active Noise Cancellation",
            "Simultaneous 2.4ghz And Bluetooth",
            "Long-Lasting Battery",
            "Premium Aluminum Build And Memory Foam Cushioning",
            "Powerful Corsair Icue Software"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767533/headphone/rwmijxyepiwran2qlqyn.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/corsair-hs55-surround-v2-wired-gaming-headset-for-pc-mac-ps5-ps4-xbox-switch-and-mobile-carbon/6594139.p?skuId=6594139",
        "name": "CORSAIR - HS55 SURROUND v2 Wired Gaming Headset for PC, Mac, PS5, PS4, Xbox, Switch, and Mobile - Carbon",
        "model": "CA-9011389-WW",
        "Noise Cancelling (Active)": "No",
        "Sound Mode": "Dolby Atmos",
        "Connection Type": "Wired",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Adjustable",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Compatible Platform(s)": "Mac/Windows, PlayStation 5, PlayStation 4, Xbox Series X, Xbox Series S, Nintendo Switch",
        "Works With": "Cortana, Google Assistant, Siri",
        "Product Name": "HS55 SURROUND v2 Wired Gaming Headset for PC, Mac, PS5, PS4, Xbox, Switch, and Mobile",
        "Brand": "CORSAIR",
        "Model Number": "CA-9011389-WW",
        "Color": "Black",
        "Sound Isolating": "No",
        "Environmental Noise Control": "Yes",
        "Minimum Frequency Response": "20 hertz",
        "Maximum Frequency Response": "20 kilohertz",
        "Impedance": "32 ohms",
        "Sensitivity": "-41 decibels adjusted",
        "Driver Size": "50 millimeters",
        "Connector Size": "1/8 in. (3.5mm), USB-A",
        "Detachable Cord": "No",
        "Controls": "Volume",
        "Lighting Type": "None",
        "Foldable Design": "No",
        "feature": [
            "Dolby Atmos Spatial Audio On Pc",
            "Hours Of Comfortable Listening",
            "Great Gaming Audio",
            "High-Quality Omni-Directional Microphone",
            "Multi-Platform Compatibility",
            "Easy-Access On-Ear Volume Control",
            "Unite Your Setup"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767534/headphone/tfzmpzjybrx2yudihaxv.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/hyperx-cloud-mini-wireless-headset-for-pc-ps5-ps4-xbox-series-xs-xbox-one-nintendo-switch-chromebook-and-mobile-red-black/6581758.p?skuId=6581758",
        "name": "HyperX - Cloud Mini Wireless Headset for PC, PS5, PS4, Xbox Series X|S, Xbox One, Nintendo Switch, Chromebook, and Mobile - Red/Black",
        "model": "7G8F1AA",
        "Connection Type": "Wireless, Wired",
        "Wireless Connectivity": "Bluetooth",
        "Built-In Microphone": "Yes",
        "Headphone Fit": "On-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "25 hours",
        "Battery Charge Time": "2 hours",
        "Compatible Platform(s)": "Mac/Windows, Chrome, PlayStation 4, PlayStation 5, Xbox One, Xbox Series S, Xbox Series X, Nintendo Switch",
        "Product Name": "Cloud Mini Wireless Headset for PC, PS5, PS4, Xbox Series X|S, Xbox One, Nintendo Switch, Chromebook, and Mobile",
        "Brand": "HyperX",
        "Model Number": "7G8F1AA",
        "Color": "Multi",
        "Sound Isolating": "No",
        "Minimum Frequency Response": "20 hertz",
        "Impedance": "114 ohms",
        "Sensitivity": "83 decibels adjusted",
        "Driver Size": "30 millimeters",
        "Connector Size": "1/8 in. (3.5mm)",
        "Detachable Cord": "Yes",
        "Controls": "Mute",
        "On/Off Switch": "Yes",
        "feature": [
            "Immersive Audio Experience",
            "All-Day Battery Life",
            "Durable Tuck-Away Microphone",
            "Lightweight Comfort In Smaller Package",
            "Rotating Earcups",
            "Versatile Multi-Platform Compatibility"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767534/headphone/h8jhwrvqvceyorurowhb.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/turtle-beach-stealth-500-wireless-amplified-gaming-headset-for-pc-ps5-ps4-nintendo-switch-mobile-with-40-hr-battery-black/6579296.p?skuId=6579296",
        "name": "Turtle Beach - Stealth™ 500 Wireless Amplified Gaming Headset for PC, PS5, PS4, Nintendo Switch, & Mobile with 40-Hr Battery - Black",
        "model": "TBS-5104-05",
        "Noise Cancelling (Active)": "No",
        "Sound Mode": "Stereo",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Radio Frequency (RF - 2.4 Ghz/Low Latency), Bluetooth",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Adjustable, Flip to mute, Noise cancelling",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "40 hours",
        "Battery Charge Time": "3 hours",
        "Compatible Platform(s)": "Windows, Nintendo Switch – OLED Model, Nintendo Switch, Steam Deck, iOS, Android, PlayStation 5, PlayStation 4",
        "Product Name": "Stealth™ 500 Wireless Amplified Gaming Headset for PC, PS5, PS4, Nintendo Switch, & Mobile with 40-Hr Battery",
        "Brand": "Turtle Beach",
        "Model Number": "TBS-5104-05",
        "Color": "Black",
        "Sound Isolating": "Yes",
        "Driver Size": "40 millimeters",
        "Controls": "Volume",
        "Lighting Type": "None",
        "Foldable Design": "Yes",
        "On/Off Switch": "Yes",
        "feature": [
            "Step Up To Wireless Freedom",
            "Best-In-Class Battery Life",
            "Quickswitch Technology",
            "Non-Stop Comfort",
            "Precise, Amplified Audio",
            "Anywhere Audio Customization",
            "Ultra-Clear, Flip-To-Mute Mic",
            "Easy Access To Audio Presets",
            "Advanced Superhuman Hearing®",
            "Variable Mic Monitoring"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767535/headphone/ezldodhrtgw5aiycujkj.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/turtle-beach-stealth-700-gen-3-wireless-amplified-gaming-headset-for-xbox-series-xs-xbox-one-pc-ps5-mobile-with-80-hr-battery-black/6583955.p?skuId=6583955",
        "name": "Turtle Beach - Stealth™ 700 Gen 3 Wireless Amplified Gaming Headset for Xbox Series X|S, Xbox One, PC, PS5, & Mobile with 80-Hr Battery - Black",
        "model": "TBS-2101-05",
        "Noise Cancelling (Active)": "Yes",
        "Sound Mode": "Stereo",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Radio Frequency (RF - 2.4 Ghz/Low Latency), Bluetooth",
        "Maximum Wireless Range": "15 feet",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "24 hours",
        "Battery Charge Time": "15 hours",
        "Compatible Platform(s)": "Windows, PlayStation 5, PlayStation 4, Xbox Series X, Xbox Series S, Xbox One, Steam Deck",
        "Product Name": "Stealth™ 700 Gen 3 Wireless Amplified Gaming Headset for Xbox Series X|S, Xbox One, PC, PS5, & Mobile with 80-Hr Battery",
        "Brand": "Turtle Beach",
        "Model Number": "TBS-2101-05",
        "Color": "Black",
        "Sound Isolating": "Yes",
        "Environmental Noise Control": "Yes",
        "Minimum Frequency Response": "20 hertz",
        "Maximum Frequency Response": "20 kilohertz",
        "Integrated Amplifier": "Yes",
        "Driver Size": "60 millimeters",
        "Bluetooth Version": "5.2",
        "Controls": "Volume",
        "Lighting Type": "None",
        "High Resolution Audio": "TRUE",
        "Foldable Design": "Yes",
        "Fast Charging": "15",
        "On/Off Switch": "Yes",
        "feature": [
            "Crossplay Multiplatform Wireless Audio System",
            "Simultaneous Wireless + Bluetooth®",
            "Stunning Audio Clarity",
            "Exceptional Microphone Performance",
            "Unstoppable, 80-Hour Battery Life",
            "Superb Comfort, Unmatched Durability",
            "Anywhere Audio Customization",
            "Remappable Wheel & Mode Button",
            "Advanced Superhuman Hearing®",
            "Easy Access To Audio Presets",
            "Variable Mic Monitoring"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767536/headphone/brrvshlf14aamdidnrcb.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/corsair-hs80-rgb-wireless-gaming-headset-for-pc-mac-ps5-ps4-carbon/6470491.p?skuId=6470491",
        "name": "CORSAIR - HS80 RGB Wireless Gaming Headset for PC, Mac, PS5, PS4 - Carbon",
        "model": "CA-9011235-NA",
        "Noise Cancelling (Active)": "No",
        "Sound Mode": "Dolby Atmos",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Radio Frequency (RF)",
        "Maximum Wireless Range": "60 feet",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Fixed",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "20 hours",
        "Battery Charge Time": "2 hours",
        "Compatible Platform(s)": "Mac/Windows, PlayStation 5, PlayStation 4",
        "Product Name": "HS80 RGB Wireless Gaming Headset for PC, Mac, PS5, PS4",
        "Brand": "CORSAIR",
        "Model Number": "CA-9011235-NA",
        "Color": "Black",
        "Sound Isolating": "No",
        "Environmental Noise Control": "No",
        "Minimum Frequency Response": "20 hertz",
        "Maximum Frequency Response": "40 kilohertz",
        "Impedance": "32 ohms",
        "Sensitivity": "109 decibels adjusted",
        "Driver Size": "50 millimeters",
        "Controls": "Mute, Volume",
        "Customizable Lighting": "Yes",
        "Lighting Type": "RGB",
        "Foldable Design": "No",
        "On/Off Switch": "Yes",
        "feature": [
            "Live The Game",
            "Hyper-Fast Slipstream Wireless",
            "Immersive Dolby Atmos On Pc",
            "Catch Every Sound",
            "Broadcast-Grade Omni-Directional Microphone",
            "Hours Of Long-Lasting Plush Comfort",
            "High-Fidelity 24bit/96khz Sound Via Usb",
            "Durable Construction",
            "Wireless Freedom",
            "Discord-Certified",
            "On-Ear Volume And Mute Controls",
            "Dynamic Rgb Lighting",
            "Powerful Corsair Icue Software",
            "Ps5 And Ps4 Wireless Compatibility"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767536/headphone/qrjk5oqzovguqaysy4ag.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/turtle-beach-recon-50p-wired-gaming-headset-for-playstation-ps5-ps4-xbox-series-x--s-xbox-one-nintendo-switch-mobile-pc-black-blue/9540009.p?skuId=9540009",
        "name": "Turtle Beach - Recon 50P Wired Gaming Headset for PlayStation, PS5, PS4, Xbox Series X | S, Xbox One, Nintendo Switch, Mobile & PC - Black/Blue",
        "model": "TBS-3303-05",
        "Sound Mode": "Stereo",
        "Connection Type": "Wired",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Detachable",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Compatible Platform(s)": "PlayStation 5, PlayStation 4, Nintendo Switch, Nintendo Switch Lite, Xbox Series X, Xbox One, Xbox Series S, Nintendo Switch – OLED Model",
        "Product Name": "Recon 50P Wired Gaming Headset for PlayStation, PS5, PS4, Xbox Series X | S, Xbox One, Nintendo Switch, Mobile & PC",
        "Brand": "Turtle Beach",
        "Model Number": "TBS-3303-05",
        "Color": "Black",
        "Sound Isolating": "Yes",
        "Minimum Frequency Response": "20 hertz",
        "Maximum Frequency Response": "20 kilohertz",
        "Impedance": "32 ohms",
        "Integrated Amplifier": "No",
        "Driver Size": "40 millimeters",
        "Connector Size": "1/8 in. (3.5mm)",
        "Detachable Cord": "No",
        "Controls": "Mute, Volume",
        "Lighting Type": "None",
        "Foldable Design": "Yes",
        "feature": [
            "Lightweight & Comfortable Design",
            "High-Quality 40mm Speakers",
            "Convenient In-Line Controls",
            "Crystal Clear Chat",
            "Versatile Compatibility"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767537/headphone/obcgzjs7yn1cbfnrkgyd.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/logitech-g735-aurora-collection-wireless-gaming-headset-for-pc-mobile-white-mist/6511305.p?skuId=6511305",
        "name": "Logitech - G735 Aurora Collection Wireless Gaming Headset for PC, Mobile - White Mist",
        "model": "981-001082",
        "Noise Cancelling (Active)": "No",
        "Sound Mode": "Dolby Atmos",
        "Connection Type": "Wireless, Wired",
        "Wireless Connectivity": "Radio Frequency (RF), Bluetooth",
        "Maximum Wireless Range": "66 feet",
        "Built-In Microphone": "Yes",
        "Carrying Case": "Yes",
        "Microphone Features": "Detachable, Adjustable",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "56 hours",
        "Compatible Platform(s)": "Windows, Mac, iOS",
        "Product Name": "G735 Aurora Collection Wireless Gaming Headset for PC, Mobile",
        "Brand": "Logitech",
        "Model Number": "981-001082",
        "Color": "White",
        "Sound Isolating": "Yes",
        "Minimum Frequency Response": "20 hertz",
        "Maximum Frequency Response": "20 kilohertz",
        "Impedance": "38 ohms",
        "Driver Size": "40 millimeters",
        "Number Of Devices Connectable Simultaneously": "2",
        "Connector Size": "1/8 in. (3.5mm)",
        "Detachable Cord": "Yes",
        "Controls": "Mute",
        "Customizable Lighting": "Yes",
        "Lighting Type": "RGB",
        "Foldable Design": "No",
        "On/Off Switch": "Yes",
        "feature": [
            "Wireless Gaming Headset With Unmatched Fit",
            "Play Across Screens",
            "Hear And Be Heard",
            "Dual Audio Mixing",
            "Cool And Comfy Gaming Headset And Mic",
            "Sound In Color",
            "From The Aurora Collection"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767538/headphone/r3iers9dyrsaiyrtqhow.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/razer-kraken-v4-x-wired-gaming-headset-with-chroma-rgb-for-pc-mac-ps5-nintendo-switch-steam-deck-smartphone-black/6586271.p?skuId=6586271",
        "name": "Razer - Kraken V4 X Wired Gaming Headset with Chroma RGB – For PC, Mac, PS5, Nintendo Switch, Steam Deck, Smartphone - Black",
        "model": "RZ04-05180100-R3U1",
        "Noise Cancelling (Active)": "Yes",
        "Sound Mode": "Surround 7.1",
        "Connection Type": "Wired",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Noise cancelling",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Compatible Platform(s)": "Windows",
        "Works With": "Cortana",
        "Product Name": "Kraken V4 X Wired Gaming Headset with Chroma RGB – For PC, Mac, PS5, Nintendo Switch, Steam Deck, Smartphone",
        "Brand": "Razer",
        "Model Number": "RZ04-05180100-R3U1",
        "Color": "Black",
        "Sound Isolating": "Yes",
        "Environmental Noise Control": "Yes",
        "Minimum Frequency Response": "20 hertz",
        "Maximum Frequency Response": "20 kilohertz",
        "Impedance": "32 ohms",
        "Sensitivity": "96 decibels adjusted",
        "Driver Size": "40 millimeters",
        "Connector Size": "USB-A, USB-C",
        "Customizable Lighting": "Yes",
        "Lighting Type": "RGB",
        "Foldable Design": "No",
        "feature": [
            "Razer Triforce 40 Mm Drivers For Powerful, Lifelike Audio",
            "Retractable Razer Hyperclear Cardioid Mic For Enhanced Voice Capture",
            "7.1 Surround Sound For Realistic Positional Sound",
            "Hybrid Fabric And Leatherette Memory Foam Cushions For All-Day Comfort And Noise Isolation",
            "Convertible Type C & Type A Cable For Multi-Platform Versatility",
            "Powered By Razer Chroma Rgb  For Greater Customization"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767539/headphone/brmbctcwuzggxpiddlvu.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/logitech-g733-lightspeed-wireless-gaming-headset-for-ps4-pc-black/6420856.p?skuId=6420856",
        "name": "Logitech - G733 LIGHTSPEED Wireless Gaming Headset for PS4, PC - Black",
        "model": "981-000863",
        "Noise Cancelling (Active)": "No",
        "Sound Mode": "DTS Headphone:X",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Radio Frequency (RF)",
        "Maximum Wireless Range": "66 feet",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Detachable, Noise cancelling",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "29 hours",
        "Battery Charge Time": "3 hours",
        "Compatible Platform(s)": "Windows, Mac, PlayStation 4",
        "Product Name": "G733 LIGHTSPEED Wireless Gaming Headset for PS4, PC",
        "Brand": "Logitech",
        "Model Number": "981-000863",
        "Color": "Black",
        "Sound Isolating": "Yes",
        "Minimum Frequency Response": "20 hertz",
        "Maximum Frequency Response": "20 kilohertz",
        "Impedance": "39 ohms",
        "Sensitivity": "87.5 decibels adjusted",
        "Driver Size": "40 millimeters",
        "Controls": "Volume",
        "Customizable Lighting": "Yes",
        "Lighting Type": "RGB",
        "Foldable Design": "No",
        "On/Off Switch": "Yes",
        "feature": [
            "Immersive Sound",
            "Comfortable, Colorful Suspension Headband",
            "Rechargeable Battery",
            "Console Compatible Gaming Headset",
            "Advanced Mic Filters",
            "2.4ghz Lightspeed Wireless Headset",
            "Soft Dual-Layer Memory Foam",
            "Lightsync Rgb ~16.8m Colors",
            "More Sustainable"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767539/headphone/n4nifmo55fbvohaxnror.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/razer-kraken-v4-wireless-gaming-headset-with-9-zone-chroma-rgb-for-pc-mac-ps5-nintendo-switch-steam-deck-smartphone-black/6586394.p?skuId=6586394",
        "name": "Razer - Kraken V4 Wireless Gaming Headset with 9 Zone Chroma RGB – For PC, Mac, PS5, Nintendo Switch, Steam Deck, Smartphone - Black",
        "model": "RZ04-05170100-R3U1",
        "Noise Cancelling (Active)": "Yes",
        "Sound Mode": "Surround 7.1",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Radio Frequency (RF - 2.4 Ghz/Low Latency), Bluetooth",
        "Maximum Wireless Range": "10 feet",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Noise cancelling",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "70 hours",
        "Compatible Platform(s)": "Windows",
        "Works With": "Cortana",
        "Product Name": "Kraken V4 Wireless Gaming Headset with 9 Zone Chroma RGB – For PC, Mac, PS5, Nintendo Switch, Steam Deck, Smartphone",
        "Brand": "Razer",
        "Model Number": "RZ04-05170100-R3U1",
        "Color": "Black",
        "Sound Isolating": "Yes",
        "Environmental Noise Control": "Yes",
        "Minimum Frequency Response": "20 hertz",
        "Maximum Frequency Response": "28 kilohertz",
        "Impedance": "32 ohms",
        "Sensitivity": "98 decibels adjusted",
        "Integrated Amplifier": "No",
        "Driver Size": "40 millimeters",
        "Bluetooth Version": "5.3",
        "Controls": "Mute",
        "Customizable Lighting": "Yes",
        "Lighting Type": "RGB",
        "Foldable Design": "No",
        "On/Off Switch": "Yes",
        "feature": [
            "3 Modes Of Connectivity Razer Hyperspeed Wireless | Bluetooth | Usb",
            "Retractable Razer Hyperclear Super Wideband Mic For High-Definition, Pro-Level Voice Quality",
            "Razer Triforce Titanium 40 Mm Drivers For Powerful, Lifelike Audio",
            "Thx Spatial Audio For Realistic Positional Sound",
            "Game/Chat Balancefor Quick Game/Chat Mix & Volume Adjustments",
            "9-Zone Earcup Lighting Powered By Razer Chroma Rgb"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767541/headphone/akjtfea8rsmwok4xkdwk.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/turtle-beach-stealth-pro-xbox-edition-wireless-noise-cancelling-gaming-headset-for-xbox-ps5-ps4-switch-and-pc-dual-batteries-black/6535754.p?skuId=6535754",
        "name": "Turtle Beach - Stealth Pro Xbox Edition Wireless Noise-Cancelling Gaming Headset for Xbox, PS5, PS4, Switch, and PC - Dual Batteries - Black",
        "model": "TBS-2360-01",
        "Noise Cancelling (Active)": "Yes",
        "Sound Mode": "Stereo",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Radio Frequency (RF - 2.4 Ghz/Low Latency), Bluetooth",
        "Maximum Wireless Range": "15 feet",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Detachable, Flip to mute, Noise cancelling",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "24 hours",
        "Battery Charge Time": "15 hours",
        "Compatible Platform(s)": "Xbox Series X, Xbox Series S, PlayStation 5, PlayStation 4, Nintendo Switch – OLED Model, Nintendo Switch, Windows, iOS, Android",
        "Product Name": "Stealth Pro Xbox Edition Wireless Noise-Cancelling Gaming Headset for Xbox, PS5, PS4, Switch, and PC - Dual Batteries",
        "Brand": "Turtle Beach",
        "Model Number": "TBS-2360-01",
        "Color": "Black",
        "Sound Isolating": "Yes",
        "Environmental Noise Control": "Yes",
        "Minimum Frequency Response": "10 hertz",
        "Maximum Frequency Response": "22 kilohertz",
        "Integrated Amplifier": "Yes",
        "Driver Size": "50 millimeters",
        "Bluetooth Version": "5.1",
        "Controls": "Volume",
        "Lighting Type": "None",
        "Foldable Design": "Yes",
        "Fast Charging": "15",
        "On/Off Switch": "Yes",
        "feature": [
            "Exceptional Audio Fidelity",
            "Unrivaled Active Noise Cancellation",
            "S.M.A.R.T. Noise-Cancelling Truspeak Boom Microphone",
            "S.M.A.R.T. Concealed Microphones",
            "Swappable Dual Battery System",
            "Bluetooth 5.1 Dual Connectivity",
            "Maximum Wireless Compatibility",
            "App-Based Audio Customization For Mobile & Desktop",
            "Advanced 10-Band Eq And Microphone Enhancements",
            "Remappable Wheel & Mode Button",
            "Sleek, Wireless Transmitter & Battery Charger",
            "Lag-Free Wireless Connection",
            "Superior Comfort",
            "Refined Aesthetic",
            "Advanced Superhuman Hearing",
            "Variable Mic Monitoring",
            "Travel-Friendly Design"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767541/headphone/ds3kqwyfkz37xgtnktgh.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/turtle-beach-recon-70-wired-gaming-headset-for-xbox-series-xs-ps5-ps4-nintendo-switch-pc-mobile-w-3-5mm-wired-connection-black/6577977.p?skuId=6577977",
        "name": "Turtle Beach - Recon 70 Wired Gaming Headset for Xbox Series X|S, PS5, PS4, Nintendo Switch, PC & Mobile w 3.5mm Wired Connection - Black",
        "model": "TBS-2001-05",
        "Sound Mode": "Dolby Atmos",
        "Connection Type": "Wired",
        "Carrying Case": "No",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Compatible Platform(s)": "Xbox Series X, Xbox Series S, Xbox One, PlayStation 5, PlayStation 4, Nintendo Switch – OLED Model, Nintendo Switch, iOS, Android",
        "Product Name": "Recon 70 Wired Gaming Headset for Xbox Series X|S, PS5, PS4, Nintendo Switch, PC & Mobile w 3.5mm Wired Connection",
        "Brand": "Turtle Beach",
        "Model Number": "TBS-2001-05",
        "Color": "Black",
        "Sound Isolating": "Yes",
        "Driver Size": "40 millimeters",
        "Connector Size": "1/8 in. (3.5mm)",
        "Controls": "Volume",
        "Lighting Type": "None",
        "Foldable Design": "Yes",
        "feature": [
            "Lightweight Comfort",
            "High Sensitivity, Flip-To-Mute Mic",
            "Surround Sound Ready",
            "High-Quality 40mm Speakers",
            "Premium Ear Cushions",
            "Multiplatform Compatibility"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767543/headphone/ciwtjej7s6zfvbcgdgcp.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/turtle-beach-atlas-air-wireless-open-back-gaming-headset-for-pc-ps5-ps4-nintendo-switch-mobile-with-floating-earcup-black/6579298.p?skuId=6579298",
        "name": "Turtle Beach - Atlas Air Wireless Open Back Gaming Headset for PC, PS5, PS4, Nintendo Switch, Mobile with Floating Earcup - Black",
        "model": "TBS-5101-05",
        "Noise Cancelling (Active)": "Yes",
        "Sound Mode": "Stereo",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Radio Frequency (RF - 2.4 Ghz/Low Latency), Bluetooth",
        "Maximum Wireless Range": "18 feet",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "24 hours",
        "Battery Charge Time": "15 hours",
        "Compatible Platform(s)": "Xbox Series X, Xbox Series S, Xbox One, PlayStation 5, PlayStation 4, Windows, Nintendo Switch – OLED Model, Nintendo Switch, Steam Deck, iOS, Android",
        "Product Name": "Atlas Air Wireless Open Back Gaming Headset for PC, PS5, PS4, Nintendo Switch, Mobile with Floating Earcup",
        "Brand": "Turtle Beach",
        "Model Number": "TBS-5101-05",
        "Color": "Black",
        "Sound Isolating": "Yes",
        "Environmental Noise Control": "Yes",
        "Minimum Frequency Response": "20 hertz",
        "Maximum Frequency Response": "40 kilohertz",
        "Integrated Amplifier": "Yes",
        "Driver Size": "40 millimeters",
        "Bluetooth Version": "5.2",
        "Controls": "Volume",
        "Lighting Type": "None",
        "High Resolution Audio": "FALSE",
        "Foldable Design": "Yes",
        "Fast Charging": "15",
        "On/Off Switch": "Yes",
        "feature": [
            "Open Back Design",
            "24-Bit Resolution, High-Fidelity Wireless Audio",
            "Floating Fit",
            "High-Precision Drivers",
            "Exceptional Broadcast Quality Microphone",
            "Lightweight Comfort",
            "Low Latency Wireless + Bluetooth",
            "Quickswitch Technology",
            "Long-Lasting Battery Life",
            "Advanced Audio & Mic Customization",
            "Waves 3d Audio For Pc",
            "Advanced Superhuman Hearing",
            "Customizable Mod Pack"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767543/headphone/etfot4393dyfjyuc2ghz.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/hyperx-cloud-ii-core-wireless-headset-for-pc-black/6581664.p?skuId=6581664",
        "name": "HyperX - Cloud II Core Wireless Headset for PC - Black",
        "model": "6Y2G8AA",
        "Noise Cancelling (Active)": "Yes",
        "Sound Mode": "DTS Headphone:X",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "None",
        "Maximum Wireless Range": "65 feet",
        "Built-In Microphone": "Yes",
        "Microphone Features": "Noise cancelling, Detachable",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "80 hours",
        "Battery Charge Time": "4.5 hours",
        "Compatible Platform(s)": "Mac/Windows",
        "Product Name": "Cloud II Core Wireless Headset for PC",
        "Brand": "HyperX",
        "Model Number": "6Y2G8AA",
        "Color": "Black",
        "Sound Isolating": "Yes",
        "Minimum Frequency Response": "10 hertz",
        "Maximum Frequency Response": "21 kilohertz",
        "Impedance": "60 ohms",
        "Controls": "Volume, Mute",
        "feature": [
            "Up To 80 Hours Battery Life",
            "Fast 2.4ghz Wireless",
            "Immersive Spatial Audio And Sound Localization",
            "Quality Audio With 53mm Drivers",
            "Stay In The Zone With Signature Hyperx Comfort",
            "Easily Access Volume And Mic Controls",
            "Detachable Noise-Cancelling Mic",
            "Durable Aluminum Frame For Reliability"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767544/headphone/u3wewykb2ninafbpbzwj.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/turtle-beach-stealth-600-wireless-gaming-headset-for-playstation-ps5-ps4-nintendo-switch-pc-with-80-hr-battery-black/6577966.p?skuId=6577966",
        "name": "Turtle Beach - Stealth™ 600 Wireless Gaming Headset for PlayStation, PS5, PS4, Nintendo Switch, PC with 80-Hr Battery - Black",
        "model": "TBS-3102-05",
        "Sound Mode": "Stereo",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Radio Frequency (RF - 2.4 Ghz/Low Latency), Bluetooth",
        "Carrying Case": "No",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Compatible Platform(s)": "PlayStation 5, PlayStation 4, Nintendo Switch – OLED Model, Nintendo Switch, Steam Deck, iOS, Android",
        "Product Name": "Stealth™ 600 Wireless Gaming Headset for PlayStation, PS5, PS4, Nintendo Switch, PC with 80-Hr Battery",
        "Brand": "Turtle Beach",
        "Model Number": "TBS-3102-05",
        "Color": "Black",
        "Sound Isolating": "Yes",
        "Driver Size": "50 millimeters",
        "Controls": "Volume",
        "Lighting Type": "None",
        "Foldable Design": "Yes",
        "On/Off Switch": "Yes",
        "feature": [
            "Multiplatform Wireless + Bluetooth",
            "Quickswitch Technology",
            "Unstoppable, 80-Hour Battery Life",
            "A.I.-Based Mic Noise Reduction",
            "Amplified 50mm Nanoclear Drivers",
            "Anywhere Audio Customization",
            "Advanced 10-Band Eq And Microphone Enhancements",
            "Remappable Wheel & Mode Button",
            "Advanced Superhuman Hearing®",
            "Easy Access To Audio Presets",
            "Variable Mic Monitoring",
            "Non-Stop Comfort"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767545/headphone/ekem6xewlv2uuj9za4nw.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/corsair-void-rgb-elite-wireless-gaming-headset-for-pc-ps5-ps4-carbon/6360425.p?skuId=6360425",
        "name": "CORSAIR - VOID RGB ELITE Wireless Gaming Headset for PC, PS5, PS4 - Carbon",
        "model": "CA-9011201-NA",
        "Noise Cancelling (Active)": "No",
        "Sound Mode": "Stereo",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Radio Frequency (RF - 2.4 Ghz/Low Latency)",
        "Maximum Wireless Range": "40 feet",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Fixed, Flip to mute",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "No",
        "Battery Life": "16 hours",
        "Battery Charge Time": "2 hours",
        "Compatible Platform(s)": "PlayStation 4, Windows, PlayStation 5",
        "Product Name": "VOID RGB ELITE Wireless Gaming Headset for PC, PS5, PS4",
        "Brand": "CORSAIR",
        "Model Number": "CA-9011201-NA",
        "Color": "Black",
        "Sound Isolating": "No",
        "Environmental Noise Control": "Yes",
        "Minimum Frequency Response": "20 hertz",
        "Maximum Frequency Response": "30 kilohertz",
        "Impedance": "32 ohms",
        "Sensitivity": "116 decibels adjusted",
        "Driver Size": "50 millimeters",
        "Controls": "Mute, Volume",
        "Customizable Lighting": "Yes",
        "Lighting Type": "RGB",
        "Foldable Design": "No",
        "On/Off Switch": "No",
        "feature": [
            "Rechargeable Battery",
            "Built-In Microphone",
            "Headset Controls"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767546/headphone/yhv8sdfj6pidtzwxpeff.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/turtle-beach-stealth-pro-playstation-edition-wireless-noise-cancelling-gaming-headset-for-ps5-ps4-switch-and-pc-dual-batteries-black/6535761.p?skuId=6535761",
        "name": "Turtle Beach - Stealth Pro PlayStation Edition Wireless Noise-Cancelling Gaming Headset for PS5, PS4, Switch and PC - Dual Batteries - Black",
        "model": "TBS-3365-01",
        "Noise Cancelling (Active)": "Yes",
        "Sound Mode": "Stereo",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Radio Frequency (RF - 2.4 Ghz/Low Latency), Bluetooth",
        "Maximum Wireless Range": "15 feet",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Detachable, Flip to mute, Noise cancelling",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "24 hours",
        "Battery Charge Time": "15 hours",
        "Compatible Platform(s)": "PlayStation 5, PlayStation 4, Nintendo Switch, Nintendo Switch – OLED Model, Windows",
        "Product Name": "Stealth Pro PlayStation Edition Wireless Noise-Cancelling Gaming Headset for PS5, PS4, Switch and PC - Dual Batteries",
        "Brand": "Turtle Beach",
        "Model Number": "TBS-3365-01",
        "Color": "Black",
        "Sound Isolating": "Yes",
        "Environmental Noise Control": "Yes",
        "Minimum Frequency Response": "10 hertz",
        "Maximum Frequency Response": "22 kilohertz",
        "Integrated Amplifier": "Yes",
        "Driver Size": "50 millimeters",
        "Bluetooth Version": "5.1",
        "Controls": "Volume",
        "Lighting Type": "None",
        "Foldable Design": "Yes",
        "Fast Charging": "15",
        "On/Off Switch": "Yes",
        "feature": [
            "Exceptional Audio Fidelity",
            "Unrivaled Active Noise Cancellation",
            "S.M.A.R.T. Noise-Cancelling Truspeak Boom Microphone",
            "S.M.A.R.T. Concealed Microphones",
            "Swappable Dual Battery System",
            "Bluetooth 5.1 Dual Connectivity",
            "Maximum Wireless Compatibility",
            "App-Based Audio Customization For Mobile & Desktop",
            "Advanced 10-Band Eq And Microphone Enhancements",
            "Remappable Wheel & Mode Button",
            "Sleek, Wireless Transmitter & Battery Charger",
            "Lag-Free Wireless Connection",
            "Superior Comfort",
            "Refined Aesthetic",
            "Advanced Superhuman Hearing",
            "Variable Mic Monitoring",
            "Travel-Friendly Design"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767547/headphone/s185aacfmsxxodzvpnrr.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/steelseries-arctis-nova-pro-wireless-multi-gaming-headset-for-xbox-series-xs-xbox-one-white/6576927.p?skuId=6576927",
        "name": "SteelSeries - Arctis Nova Pro Wireless Multi Gaming Headset for Xbox Series X|S, Xbox One - White",
        "model": "61525",
        "Noise Cancelling (Active)": "Yes",
        "Sound Mode": "Surround 7.1",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Radio Frequency (RF - 2.4 Ghz/Low Latency), Bluetooth",
        "Maximum Wireless Range": "30 feet",
        "Built-In Microphone": "Yes",
        "Carrying Case": "Yes",
        "Microphone Features": "Retractable, Noise cancelling",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "44 hours",
        "Battery Charge Time": "4 hours",
        "Compatible Platform(s)": "Windows, Mac, Xbox Series X, Xbox Series S, Xbox One, PlayStation 4, PlayStation 5, Nintendo Switch",
        "Product Name": "Arctis Nova Pro Wireless Multi Gaming Headset for Xbox Series X|S, Xbox One",
        "Brand": "SteelSeries",
        "Model Number": "61525",
        "Color": "White",
        "Sound Isolating": "Yes",
        "Environmental Noise Control": "Yes",
        "Minimum Frequency Response": "10 hertz",
        "Maximum Frequency Response": "22 kilohertz",
        "Sensitivity": "93 decibels adjusted",
        "Integrated Amplifier": "Yes",
        "Driver Size": "40 millimeters",
        "Bluetooth Version": "5.0",
        "Controls": "Volume, Mute",
        "Lighting Type": "None",
        "High Resolution Audio": "True",
        "Foldable Design": "Yes",
        "Fast Charging": "Yes",
        "On/Off Switch": "Yes",
        "feature": [
            "Worn By Champions",
            "Active Noise Cancellation",
            "Neodymium Magnetic Drivers",
            "Onboard Audio Profiles",
            "Unlimited Battery Life",
            "Multi-System Connect",
            "Simultaneous Bluetooth"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767548/headphone/zhbftsewvhreo1gpx4lh.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/turtle-beach-stealth-500-wireless-amplified-gaming-headset-for-ps5-ps4-pc-nintendo-switch-mobile-with-40-hr-battery-black/6577935.p?skuId=6577935",
        "name": "Turtle Beach - Stealth™ 500 Wireless Amplified Gaming Headset for PS5, PS4, PC, Nintendo Switch, & Mobile with 40-Hr Battery - Black",
        "model": "TBS-3103-05",
        "Sound Mode": "Stereo",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Radio Frequency (RF - 2.4 Ghz/Low Latency), Bluetooth",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Adjustable, Flip to mute, Noise cancelling",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "40 hours",
        "Compatible Platform(s)": "PlayStation 5, PlayStation 4, Nintendo Switch – OLED Model, Nintendo Switch, Steam Deck, iOS, Android",
        "Product Name": "Stealth™ 500 Wireless Amplified Gaming Headset for PS5, PS4, PC, Nintendo Switch, & Mobile with 40-Hr Battery",
        "Brand": "Turtle Beach",
        "Model Number": "TBS-3103-05",
        "Color": "Black",
        "Sound Isolating": "Yes",
        "Driver Size": "40 millimeters",
        "Controls": "Volume",
        "Lighting Type": "None",
        "Foldable Design": "Yes",
        "On/Off Switch": "Yes",
        "feature": [
            "Step Up To Wireless Freedom",
            "Best-In-Class Battery Life",
            "Quickswitch Technology",
            "Non-Stop Comfort",
            "Precise, Amplified Audio",
            "Anywhere Audio Customization",
            "Ultra-Clear, Flip-To-Mute Mic",
            "Easy Access To Audio Presets",
            "Advanced Superhuman Hearing®",
            "Variable Mic Monitoring"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767549/headphone/nle86xmpmutsphgqv822.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/logitech-g435-wireless-gaming-headset-for-pc-ps5-ps4-nintendo-switch-mobile-black/6478273.p?skuId=6478273",
        "name": "Logitech - G435 Wireless Gaming Headset for PC, PS5, PS4, Nintendo Switch, Mobile - Black",
        "model": "981-001049",
        "Noise Cancelling (Active)": "No",
        "Sound Mode": "Dolby Atmos",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Bluetooth, Radio Frequency (RF)",
        "Maximum Wireless Range": "33 feet",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Fixed",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "18 hours",
        "Compatible Platform(s)": "Windows, Mac, PlayStation 5, PlayStation 4, Nintendo Switch",
        "Product Name": "G435 Wireless Gaming Headset for PC, PS5, PS4, Nintendo Switch, Mobile",
        "Brand": "Logitech",
        "Model Number": "981-001049",
        "Color": "Black",
        "Sound Isolating": "No",
        "Minimum Frequency Response": "20 hertz",
        "Maximum Frequency Response": "20 kilohertz",
        "Impedance": "45 ohms",
        "Sensitivity": "83.1 decibels adjusted",
        "Driver Size": "40 millimeters",
        "Controls": "Volume, Mute",
        "Lighting Type": "None",
        "Foldable Design": "No",
        "On/Off Switch": "Yes",
        "feature": [
            "Immersive Sound",
            "Long Battery Life",
            "Superior Voice Quality",
            "Versatile Wireless Headset",
            "Lightweight Design",
            "Total Comfort",
            "Safer",
            "More Sustainable"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767550/headphone/jiragahtpxboax4gejhz.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/razer-kraken-v3-pro-hypersense-wireless-gaming-headset-for-pc-black/6480356.p?skuId=6480356",
        "name": "Razer - Kraken V3 Pro HyperSense Wireless Gaming Headset for PC - Black",
        "model": "RZ04-03460100-R3U1",
        "Noise Cancelling (Active)": "No",
        "Sound Mode": "Surround 7.1",
        "Connection Type": "Wireless, Wired",
        "Wireless Connectivity": "Radio Frequency (RF - 2.4 Ghz/Low Latency)",
        "Maximum Wireless Range": "10 feet",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Detachable",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "11 hours",
        "Compatible Platform(s)": "Mac/Windows, PlayStation 4, PlayStation 5",
        "Product Name": "Kraken V3 Pro HyperSense Wireless Gaming Headset for PC",
        "Brand": "Razer",
        "Model Number": "RZ04-03460100-R3U1",
        "Color": "Black",
        "Sound Isolating": "Yes",
        "Environmental Noise Control": "Yes",
        "Minimum Frequency Response": "20 hertz",
        "Maximum Frequency Response": "20 kilohertz",
        "Impedance": "32 ohms",
        "Sensitivity": "95 decibels adjusted",
        "Integrated Amplifier": "No",
        "Driver Size": "50 millimeters",
        "Connector Size": "USB-C",
        "Detachable Cord": "Yes",
        "Controls": "Volume, Mute",
        "Customizable Lighting": "Yes",
        "Lighting Type": "RGB",
        "High Resolution Audio": "THX Spatial Audio",
        "Foldable Design": "No",
        "On/Off Switch": "Yes",
        "feature": [
            "Razer Hypersense",
            "Razer Triforce Titanium 50mm Drivers",
            "Thx Spatial Audio",
            "Razer Hyperspeed Wireless Technology",
            "Hybrid Fabric And Leatherette Memory Foam Cushions",
            "Detachable Razer Hyperclear Supercardioid Mic",
            "Compatibility"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767551/headphone/uxvyxstzbmp4zv7ump84.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/logitech-g435-wireless-gaming-headset-for-pc-ps5-ps4-nintendo-switch-mobile-black/6478273.p?skuId=6478273",
        "name": "Logitech - G435 Wireless Gaming Headset for PC, PS5, PS4, Nintendo Switch, Mobile - Black",
        "model": "981-001049",
        "Noise Cancelling (Active)": "No",
        "Sound Mode": "Dolby Atmos",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Bluetooth, Radio Frequency (RF)",
        "Maximum Wireless Range": "33 feet",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Fixed",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "18 hours",
        "Compatible Platform(s)": "Windows, Mac, PlayStation 5, PlayStation 4, Nintendo Switch",
        "Product Name": "G435 Wireless Gaming Headset for PC, PS5, PS4, Nintendo Switch, Mobile",
        "Brand": "Logitech",
        "Model Number": "981-001049",
        "Color": "Black",
        "Sound Isolating": "No",
        "Minimum Frequency Response": "20 hertz",
        "Maximum Frequency Response": "20 kilohertz",
        "Impedance": "45 ohms",
        "Sensitivity": "83.1 decibels adjusted",
        "Driver Size": "40 millimeters",
        "Controls": "Volume, Mute",
        "Lighting Type": "None",
        "Foldable Design": "No",
        "On/Off Switch": "Yes",
        "feature": [
            "Immersive Sound",
            "Long Battery Life",
            "Superior Voice Quality",
            "Versatile Wireless Headset",
            "Lightweight Design",
            "Total Comfort",
            "Safer",
            "More Sustainable"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767552/headphone/xhh92cstejbp9sqdzlmp.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/turtle-beach-recon-70-wired-multiplatform-gaming-headset-for-ps5-ps4-xbox-series-xs-switch-pc-mobile-with-3-5mm-connection-black/6577971.p?skuId=6577971",
        "name": "Turtle Beach - Recon 70 Wired Multiplatform Gaming Headset for PS5, PS4, Xbox Series X|S, Switch, PC & Mobile with 3.5mm Connection - Black",
        "model": "TBS-3001-05",
        "Connection Type": "Wired",
        "Carrying Case": "No",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Compatible Platform(s)": "Xbox Series X, Xbox Series S, Xbox One, PlayStation 5, PlayStation 4, Nintendo Switch – OLED Model, Nintendo Switch, iOS, Android",
        "Product Name": "Recon 70 Wired Multiplatform Gaming Headset for PS5, PS4, Xbox Series X|S, Switch, PC & Mobile with 3.5mm Connection",
        "Brand": "Turtle Beach",
        "Model Number": "TBS-3001-05",
        "Color": "Black",
        "Sound Isolating": "Yes",
        "Driver Size": "40 millimeters",
        "Connector Size": "1/8 in. (3.5mm)",
        "Controls": "Volume",
        "Lighting Type": "None",
        "Foldable Design": "Yes",
        "feature": [
            "Lightweight Comfort",
            "High Sensitivity, Flip-To-Mute Mic",
            "Surround Sound Ready",
            "High-Quality 40mm Speakers",
            "Premium Ear Cushions",
            "Multiplatform Compatibility"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767553/headphone/ktswxyjlbhcf5nd3plte.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/turtle-beach-stealth-600-wireless-multiplatform-gaming-headset-for-pc-ps5-ps4-nintendo-switch-mobile-with-80-hr-battery-black/6579297.p?skuId=6579297",
        "name": "Turtle Beach - Stealth™ 600 Wireless Multiplatform Gaming Headset for PC, PS5, PS4, Nintendo Switch & Mobile with 80-Hr Battery - Black",
        "model": "TBS-5103-05",
        "Noise Cancelling (Active)": "Yes",
        "Sound Mode": "Surround",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Radio Frequency (RF - 2.4 Ghz/Low Latency), Bluetooth",
        "Maximum Wireless Range": "15 feet",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "24 hours",
        "Battery Charge Time": "15 hours",
        "Compatible Platform(s)": "PlayStation 5, Windows, PlayStation 4, Nintendo Switch – OLED Model, Nintendo Switch, Steam Deck, iOS, Android",
        "Product Name": "Stealth™ 600 Wireless Multiplatform Gaming Headset for PC, PS5, PS4, Nintendo Switch & Mobile with 80-Hr Battery",
        "Brand": "Turtle Beach",
        "Model Number": "TBS-5103-05",
        "Color": "Black",
        "Sound Isolating": "Yes",
        "Environmental Noise Control": "Yes",
        "Minimum Frequency Response": "20 hertz",
        "Maximum Frequency Response": "20 kilohertz",
        "Integrated Amplifier": "Yes",
        "Driver Size": "50 millimeters",
        "Bluetooth Version": "5.2",
        "Controls": "Volume",
        "Lighting Type": "None",
        "High Resolution Audio": "TRUE",
        "Foldable Design": "Yes",
        "Fast Charging": "15",
        "On/Off Switch": "Yes",
        "feature": [
            "Multiplatform Wireless + Bluetooth",
            "Quickswitch Technology",
            "Unstoppable, 80-Hour Battery Life",
            "A.I.-Based Mic Noise Reduction",
            "Waves 3d Audio For Pc",
            "Amplified 50mm Nanoclear Drivers",
            "Anywhere Audio Customization",
            "Advanced 10-Band Eq And Microphone Enhancements",
            "Remappable Wheel & Button",
            "Advanced Superhuman Hearing",
            "Easy Access To Audio Presets",
            "Variable Mic Monitoring",
            "Non-Stop Comfort",
            "Lay-Flat, Adjustable Design"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767554/headphone/kkmktwmzysfcllefigcb.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/rig-600-pro-hx-dual-wireless-gaming-headset-with-bluetooth-dolby-atmos-3d-audio-for-xbox-playstation-nintendo-switch-pc-black/6557104.p?skuId=6557104",
        "name": "RIG - 600 Pro HX Dual Wireless Gaming Headset with Bluetooth & Dolby Atmos 3D Audio for Xbox, PlayStation, Nintendo Switch, PC - Black",
        "model": "10-1677-01",
        "Noise Cancelling (Active)": "Yes",
        "Sound Mode": "Stereo",
        "Connection Type": "Wireless, Wired",
        "Wireless Connectivity": "Bluetooth",
        "Headphone Fit": "Over-the-Ear",
        "Compatible Platform(s)": "Xbox One, Xbox Series S, Xbox Series X, Windows",
        "Works With": "Siri",
        "Product Name": "600 Pro HX Dual Wireless Gaming Headset with Bluetooth & Dolby Atmos 3D Audio for Xbox, PlayStation, Nintendo Switch, PC",
        "Brand": "RIG",
        "Model Number": "10-1677-01",
        "Color": "Black",
        "Sound Isolating": "Yes",
        "Environmental Noise Control": "Yes",
        "Integrated Amplifier": "No",
        "Number Of Devices Connectable Simultaneously": "1",
        "Connector Size": "USB-C",
        "Detachable Cord": "Yes",
        "Lighting Type": "None",
        "Foldable Design": "No",
        "On/Off Switch": "Yes",
        "feature": [
            "Experience Unmatched Audio",
            "Gain A Competitive Edge",
            "Dual Mode Wireless",
            "High Quality Microphone",
            "Enjoy All Day Comfort Fit",
            "Balance Controls",
            "Customization",
            "Battery Life"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767555/headphone/tsanlite7c92mzovddbf.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/turtle-beach-stealth-600-wireless-gaming-headset-for-playstation-ps5-ps4-nintendo-switch-pc-with-80-hr-battery-black/6577966.p?skuId=6577966",
        "name": "Turtle Beach - Stealth™ 600 Wireless Gaming Headset for PlayStation, PS5, PS4, Nintendo Switch, PC with 80-Hr Battery - Black",
        "model": "TBS-3102-05",
        "Sound Mode": "Stereo",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Radio Frequency (RF - 2.4 Ghz/Low Latency), Bluetooth",
        "Carrying Case": "No",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Compatible Platform(s)": "PlayStation 5, PlayStation 4, Nintendo Switch – OLED Model, Nintendo Switch, Steam Deck, iOS, Android",
        "Product Name": "Stealth™ 600 Wireless Gaming Headset for PlayStation, PS5, PS4, Nintendo Switch, PC with 80-Hr Battery",
        "Brand": "Turtle Beach",
        "Model Number": "TBS-3102-05",
        "Color": "Black",
        "Sound Isolating": "Yes",
        "Driver Size": "50 millimeters",
        "Controls": "Volume",
        "Lighting Type": "None",
        "Foldable Design": "Yes",
        "On/Off Switch": "Yes",
        "feature": [
            "Multiplatform Wireless + Bluetooth",
            "Quickswitch Technology",
            "Unstoppable, 80-Hour Battery Life",
            "A.I.-Based Mic Noise Reduction",
            "Amplified 50mm Nanoclear Drivers",
            "Anywhere Audio Customization",
            "Advanced 10-Band Eq And Microphone Enhancements",
            "Remappable Wheel & Mode Button",
            "Advanced Superhuman Hearing®",
            "Easy Access To Audio Presets",
            "Variable Mic Monitoring",
            "Non-Stop Comfort"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767556/headphone/tuaprmwwyjsgsgzqdpck.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/turtle-beach-stealth-700-gen-3-wireless-multiplatform-amplified-gaming-headset-for-ps5-ps4-pc-mobile-with-80-hr-battery-black/6583839.p?skuId=6583839",
        "name": "Turtle Beach - Stealth™ 700 Gen 3 Wireless Multiplatform Amplified Gaming Headset for PS5, PS4, PC, & Mobile with 80-Hr Battery - Black",
        "model": "TBS-3101-05",
        "Noise Cancelling (Active)": "Yes",
        "Sound Mode": "Stereo",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Radio Frequency (RF - 2.4 Ghz/Low Latency), Bluetooth",
        "Maximum Wireless Range": "15 feet",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "24 hours",
        "Battery Charge Time": "15 hours",
        "Compatible Platform(s)": "Windows, PlayStation 5, PlayStation 4, Steam Deck",
        "Product Name": "Stealth™ 700 Gen 3 Wireless Multiplatform Amplified Gaming Headset for PS5, PS4, PC, & Mobile with 80-Hr Battery",
        "Brand": "Turtle Beach",
        "Model Number": "TBS-3101-05",
        "Color": "Black",
        "Sound Isolating": "Yes",
        "Environmental Noise Control": "Yes",
        "Minimum Frequency Response": "20 hertz",
        "Maximum Frequency Response": "20 kilohertz",
        "Integrated Amplifier": "Yes",
        "Driver Size": "60 millimeters",
        "Bluetooth Version": "5.2",
        "Controls": "Volume",
        "Lighting Type": "None",
        "High Resolution Audio": "TRUE",
        "Foldable Design": "Yes",
        "Fast Charging": "15",
        "On/Off Switch": "Yes",
        "feature": [
            "Crossplay Multiplatform Wireless Audio System",
            "Simultaneous Wireless + Bluetooth®",
            "Stunning Audio Clarity",
            "Exceptional Microphone Performance",
            "Unstoppable, 80-Hour Battery Life",
            "Superb Comfort, Unmatched Durability",
            "Anywhere Audio Customization",
            "Remappable Wheel & Mode Button",
            "Advanced Superhuman Hearing®",
            "Easy Access To Audio Presets",
            "Variable Mic Monitoring"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767557/headphone/vplgnixxandjytqehy0a.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/razer-kraken-kitty-v2-bt-wireless-gaming-headset-with-chroma-rgb-hello-kitty-edition-pink/6586264.p?skuId=6586264",
        "name": "Razer - Kraken Kitty V2 BT Wireless Gaming Headset with Chroma RGB - Hello Kitty Edition - Pink",
        "model": "RZ04-04860200-R3M1",
        "Noise Cancelling (Active)": "No",
        "Sound Mode": "Stereo",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Bluetooth",
        "Maximum Wireless Range": "10 feet",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Noise cancelling",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Compatible Platform(s)": "Windows, Mac",
        "Works With": "Cortana",
        "Product Name": "Kraken Kitty V2 BT Wireless Gaming Headset with Chroma RGB - Hello Kitty Edition",
        "Brand": "Razer",
        "Model Number": "RZ04-04860200-R3M1",
        "Color": "Pink",
        "Sound Isolating": "Yes",
        "Environmental Noise Control": "Yes",
        "Minimum Frequency Response": "20 hertz",
        "Maximum Frequency Response": "20 kilohertz",
        "Impedance": "32 ohms",
        "Sensitivity": "92.5 decibels adjusted",
        "Integrated Amplifier": "No",
        "Driver Size": "40 millimeters",
        "Bluetooth Version": "5.2",
        "Controls": "Volume, Mute",
        "Customizable Lighting": "Yes",
        "Lighting Type": "RGB",
        "High Resolution Audio": "THX Spatial Audio",
        "Foldable Design": "No",
        "On/Off Switch": "Yes",
        "feature": [
            "Kitty Ears And Earcups Powered By Razer Chroma Rgb",
            "Bluetooth 5.2 With Gaming Mode For Seamless, Low-Latency Performance",
            "Razer Triforce 40 Mm Drivers For Clear, Powerful Sound",
            "Integrated Beamforming Noise-Cancelling Mics For Crystal-Clear Voice Pickup",
            "325 G Lightweight Build For All-Day Comfort",
            "Up To 40-Hour Battery Life With Type C Charging For Non-Stop Streaming And Everyday Use."
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767558/headphone/f1kcnl91xyemucnqxtst.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/alienware-aw725h-tri-mode-wireless-gaming-headset-for-pc-xbox-xs-xbox-one-ps5-ps4-switch-and-mobile-lunar-light/6605026.p?skuId=6605026",
        "name": "Alienware - AW725H Tri Mode Wireless Gaming Headset for PC, Xbox X|S, Xbox One, PS5, PS4, Switch and Mobile - Lunar Light",
        "model": "AW725H - LL",
        "Noise Cancelling (Active)": "No",
        "Sound Mode": "Dolby Atmos",
        "Connection Type": "Wireless, Wired",
        "Wireless Connectivity": "Bluetooth, Radio Frequency (RF - 2.4 Ghz/Low Latency)",
        "Maximum Wireless Range": "100 feet",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Noise cancelling, Retractable",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "55 hours",
        "Battery Charge Time": "0.25 hours",
        "Compatible Platform(s)": "Windows, Android, iOS, Xbox, PlayStation 4, PlayStation 5, Nintendo Switch",
        "Product Name": "AW725H Tri Mode Wireless Gaming Headset for PC, Xbox X|S, Xbox One, PS5, PS4, Switch and Mobile",
        "Brand": "Alienware",
        "Model Number": "AW725H - LL",
        "Color": "Multi",
        "Sound Isolating": "Yes",
        "Impedance": "32 ohms",
        "Bluetooth Version": "5.3",
        "Connector Size": "1/8 in. (3.5mm)",
        "Detachable Cord": "Yes",
        "feature": [
            "Designed For Comfort",
            "Spacious. Breathable. Soft.",
            "Immersive Gaming Audio",
            "Personalize Your Lighting",
            "Uncompromised Performance"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767559/headphone/efvzeuo1tpy9y6572jjc.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/sony-inzone-h5-wireless-gaming-headset-black/6562125.p?skuId=6562125",
        "name": "Sony - INZONE H5 Wireless Gaming Headset - Black",
        "model": "WHG500/B",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Radio Frequency (RF - 2.4 Ghz/Low Latency)",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "28 hours",
        "Compatible Platform(s)": "PlayStation, Windows",
        "Product Name": "INZONE H5 Wireless Gaming Headset",
        "Brand": "Sony",
        "Model Number": "WHG500/B",
        "Color": "Black",
        "Sound Isolating": "No",
        "feature": [
            "360 Spatial Sound For Gaming",
            "Lightweight, Comfortable, Durable",
            "Ai Technology That Isolates Your Voice",
            "Up To 28 Hours Of Play",
            "Richer Highs, More Powerful Lows",
            "Wireless Or Wired, It'S Your Choice"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767561/headphone/wiv7tnpghsbfc4rl4ytx.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/hyperx-cloud-iii-wired-gaming-headset-for-pc-ps5-ps4-xbox-series-xs-xbox-one-nintendo-switch-and-mobile-black/6542541.p?skuId=6542541",
        "name": "HyperX - Cloud III Wired Gaming Headset for PC, PS5, PS4, Xbox Series X|S, Xbox One, Nintendo Switch, and Mobile - Black",
        "model": "727A8AA",
        "Noise Cancelling (Active)": "Yes",
        "Sound Mode": "DTS Headphone:X",
        "Connection Type": "Wired",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Noise cancelling, Detachable",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Compatible Platform(s)": "Windows, PlayStation 5, Xbox Series X, Xbox Series S, Xbox One, Nintendo Switch, Android, iOS",
        "Product Name": "Cloud III Wired Gaming Headset for PC, PS5, PS4, Xbox Series X|S, Xbox One, Nintendo Switch, and Mobile",
        "Brand": "HyperX",
        "Model Number": "727A8AA",
        "Color": "Black",
        "Sound Isolating": "No",
        "Environmental Noise Control": "No",
        "Minimum Frequency Response": "10 hertz",
        "Maximum Frequency Response": "21 kilohertz",
        "Impedance": "64 ohms",
        "Sensitivity": "100 decibels adjusted",
        "Integrated Amplifier": "No",
        "Driver Size": "53 millimeters",
        "Connector Size": "1/8 in. (3.5mm)",
        "Detachable Cord": "Yes",
        "Controls": "Volume, Mute",
        "Lighting Type": "None",
        "High Resolution Audio": "No",
        "Foldable Design": "No",
        "feature": [
            "Comfort Is King",
            "Audio Tuned For Your Entertainment",
            "Upgraded Microphone For Clarity And Accuracy",
            "Durability, For The Toughest Of Battles",
            "Dts Headphone:X Spatial Audio",
            "Quick, Convenient Audio And Mic Controls",
            "Versatile Compatibility Via Usb-C, Usb-A, And 3.5mm"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767562/headphone/hndrpbcy46agntkarkxu.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/fifine-pc-gaming-headset-usb-headset-with-7-1-surround-sound-for-ps5-xbox-switch-ampligame-h9-black/6601912.p?skuId=6601912",
        "name": "FIFINE - PC Gaming Headset, USB Headset with 7.1 Surround Sound for PS5/Xbox/Switch, AmpliGame H9 - Black",
        "model": "H9",
        "Noise Cancelling (Active)": "No",
        "Connection Type": "Wired",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Compatible Platform(s)": "Windows, iOS, Xbox, PlayStation 4, PlayStation 5",
        "Product Name": "PC Gaming Headset, USB Headset with 7.1 Surround Sound for PS5/Xbox/Switch, AmpliGame H9",
        "Brand": "FIFINE",
        "Model Number": "H9",
        "Color": "Black",
        "Sound Isolating": "No",
        "Impedance": "32 ohms",
        "Sensitivity": "-42 decibels adjusted",
        "Integrated Amplifier": "No",
        "Connector Size": "Micro-USB A, 1/8 in. (3.5mm)",
        "Detachable Cord": "No",
        "Foldable Design": "No",
        "feature": [
            "Immersive 7.1 Surround Sound",
            "Universal Compatibility",
            "Long-Lasting Comfort",
            "Detachable Microphone For Clear Communication",
            "Elevated Gaming Accuracy And Achievement"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767563/headphone/kbhcugyclromjeszetj6.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/logitech-g432-wired-gaming-headset-for-pc-black-blue/6320789.p?skuId=6320789",
        "name": "Logitech - G432 Wired Gaming Headset for PC - Black/Blue",
        "model": "981-000769",
        "Noise Cancelling (Active)": "No",
        "Sound Mode": "DTS Headphone:X 2.0",
        "Connection Type": "Wired",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Adjustable",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Compatible Platform(s)": "Windows, Mac, Nintendo Switch, PlayStation 5, PlayStation 4, Xbox One",
        "Product Name": "G432 Wired Gaming Headset for PC",
        "Brand": "Logitech",
        "Model Number": "981-000769",
        "Color": "Black",
        "Sound Isolating": "No",
        "Minimum Frequency Response": "20 hertz",
        "Maximum Frequency Response": "20 kilohertz",
        "Impedance": "39 ohms",
        "Sensitivity": "107 decibels adjusted",
        "Driver Size": "50 millimeters",
        "Connector Size": "USB-A",
        "Controls": "Volume",
        "Lighting Type": "None",
        "Foldable Design": "No",
        "feature": [
            "50 Mm Audio Drivers For Detailed Audio",
            "Dts Headphone:X 2.0",
            "Large 6 Mm Flip-To-Mute Mic And Volume Control",
            "Multi-Platform Compatibility",
            "Game For Hours In Comfort",
            "More Sustainable"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767564/headphone/igvpecq14ebejbylm9mf.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/razer-barracuda-pro-wireless-gaming-headset-for-pc-ps5-ps4-switch-and-mobile-black/6502761.p?skuId=6502761",
        "name": "Razer - Barracuda Pro Wireless Gaming Headset for PC, PS5, PS4, Switch, and Mobile - Black",
        "model": "RZ04-03780100-R3U1",
        "Noise Cancelling (Active)": "Yes",
        "Sound Mode": "Stereo, Simulated Surround",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Bluetooth, Radio Frequency (RF)",
        "Maximum Wireless Range": "10 feet",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Fixed, Noise cancelling",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "40 hours",
        "Compatible Platform(s)": "Mac/Windows, PlayStation 4, PlayStation 5, Nintendo Switch, Android",
        "Works With": "Cortana",
        "Product Name": "Barracuda Pro Wireless Gaming Headset for PC, PS5, PS4, Switch, and Mobile",
        "Brand": "Razer",
        "Model Number": "RZ04-03780100-R3U1",
        "Color": "Black",
        "Sound Isolating": "Yes",
        "Environmental Noise Control": "Yes",
        "Minimum Frequency Response": "20 hertz",
        "Maximum Frequency Response": "28 kilohertz",
        "Impedance": "32 ohms",
        "Sensitivity": "108 decibels adjusted",
        "Integrated Amplifier": "No",
        "Driver Size": "50 millimeters",
        "Bluetooth Version": "5.2",
        "Controls": "Volume, Mute",
        "Lighting Type": "None",
        "High Resolution Audio": "THX Spatial Audio",
        "Foldable Design": "No",
        "On/Off Switch": "Yes",
        "feature": [
            "Hybrid Active Noise Cancellation (Anc) Technology",
            "Thx Achromatic Audio Amplifier (Thx Aaa)",
            "Razer Smartswitch Dual Wireless",
            "Razer Triforce Bio-Cellulose 50mm Drivers",
            "Integrated Beamforming Noise-Cancelling Mics",
            "Razer Audio App"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767565/headphone/apvh9w6eweoarffoskal.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/logitech-g535-lightspeed-wireless-gaming-headset-for-pc-ps5-ps4-black/6478276.p?skuId=6478276",
        "name": "Logitech - G535 LIGHTSPEED Wireless Gaming Headset for PC, PS5, PS4 - Black",
        "model": "981-000971",
        "Noise Cancelling (Active)": "No",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Radio Frequency (RF)",
        "Maximum Wireless Range": "39 feet",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Flip to mute, Adjustable",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "33 hours",
        "Compatible Platform(s)": "Mac/Windows, PlayStation 5, PlayStation 4",
        "Product Name": "G535 LIGHTSPEED Wireless Gaming Headset for PC, PS5, PS4",
        "Brand": "Logitech",
        "Model Number": "981-000971",
        "Color": "Black",
        "Sound Isolating": "Yes",
        "Minimum Frequency Response": "20 hertz",
        "Maximum Frequency Response": "20 kilohertz",
        "Impedance": "36 ohms",
        "Sensitivity": "87.5 decibels adjusted",
        "Driver Size": "40 millimeters",
        "Controls": "Volume, Mute",
        "Lighting Type": "None",
        "Foldable Design": "No",
        "On/Off Switch": "Yes",
        "feature": [
            "40 Mm Drivers",
            "Lightspeed Wireless",
            "Pc And Console Compatible",
            "Plug And Play",
            "Lightweight Materials",
            "On-Ear Controls",
            "All-Day Comfort",
            "Discord Certified",
            "More Sustainable"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767565/headphone/fejhu9uwu6actlvlyiir.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/corsair-hs80-rgb-wired-gaming-headset-for-pc-carbon/6506968.p?skuId=6506968",
        "name": "CORSAIR - HS80 RGB Wired Gaming Headset for PC - Carbon",
        "model": "CA-9011237-NA",
        "Noise Cancelling (Active)": "Yes",
        "Sound Mode": "Stereo",
        "Connection Type": "Wired",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Fixed, Flip to mute",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Compatible Platform(s)": "Mac/Windows",
        "Product Name": "HS80 RGB Wired Gaming Headset for PC",
        "Brand": "CORSAIR",
        "Model Number": "CA-9011237-NA",
        "Color": "Black",
        "Sound Isolating": "No",
        "Environmental Noise Control": "No",
        "Minimum Frequency Response": "20 hertz",
        "Maximum Frequency Response": "40 kilohertz",
        "Impedance": "32 ohms",
        "Sensitivity": "116 decibels adjusted",
        "Driver Size": "50 millimeters",
        "Connector Size": "USB-A",
        "Detachable Cord": "No",
        "Controls": "Mute, Volume",
        "Customizable Lighting": "Yes",
        "Lighting Type": "RGB",
        "Foldable Design": "No",
        "feature": [
            "Live The Game",
            "Dolby Audio 7.1 Surround Sound",
            "On-Ear Volume And Mute Controls",
            "Hours Of Long-Lasting Plush Comfort",
            "Durable Construction",
            "Powerful Corsair Icue Software On Both Windows And Macos"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767567/headphone/xcvcmr0bwn6vxdjngo8r.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/asus-rog-cetra-true-wireless-speednova-in-ear-gaming-earbuds-white/6595751.p?skuId=6595751",
        "name": "ASUS - ROG Cetra True Wireless SpeedNova In-Ear Gaming Earbuds - White",
        "model": "CETRA TWS SPEEDNOVA/WHT",
        "Noise Cancelling (Active)": "Yes",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Bluetooth, Radio Frequency (RF - 2.4 Ghz/Low Latency)",
        "Built-In Microphone": "Yes",
        "Microphone Features": "Fixed",
        "Headphone Fit": "In-Ear",
        "Battery Life": "46 hours",
        "Compatible Platform(s)": "Windows, Mac, Android, iOS, Nintendo Switch",
        "Works With": "Amazon Alexa, Google Assistant, Bixby, Siri",
        "Product Name": "ROG Cetra True Wireless SpeedNova In-Ear Gaming Earbuds",
        "Brand": "ASUS",
        "Model Number": "CETRA TWS SPEEDNOVA/WHT",
        "Color": "White",
        "Sound Isolating": "Yes",
        "Bluetooth Version": "5.3",
        "Controls": "Track selection, Voice assistant",
        "Customizable Lighting": "Yes",
        "Lighting Type": "RGB",
        "feature": [
            "Dual-Mode Wireless Connectivity",
            "Rog Speednova Wireless Technology",
            "Realistic Audio",
            "Bone-Conduction Ai Microphones",
            "Adaptive Anc With Auto Mode",
            "Hybrid Multipoint",
            "Extensive Battery Life",
            "Asus Aura Rgb Lighting"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767568/headphone/ozaxcwy9fjfgll8sb7eo.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/edifier-g5bt-wireless-gaming-headset-with-40-hour-battery-life-rgb-lighting-for-xbox-xs-playstation-nintendo-mobile-pc-black/6584549.p?skuId=6584549",
        "name": "Edifier - G5BT Wireless Gaming Headset with 40 Hour Battery Life, RGB lighting for Xbox X|S, Playstation, Nintendo, Mobile & PC - Black",
        "model": "G5BT BLACK",
        "Connection Type": "Wireless, Wired",
        "Wireless Connectivity": "Bluetooth",
        "Maximum Wireless Range": "32.8 feet",
        "Built-In Microphone": "Yes",
        "Microphone Features": "Noise cancelling, Retractable",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "40 hours",
        "Battery Charge Time": "2 hours",
        "Compatible Platform(s)": "Universal",
        "Product Name": "G5BT Wireless Gaming Headset with 40 Hour Battery Life, RGB lighting for Xbox X|S, Playstation, Nintendo, Mobile & PC",
        "Brand": "Edifier",
        "Model Number": "G5BT BLACK",
        "Color": "Black",
        "Sound Isolating": "No",
        "Minimum Frequency Response": "20 hertz",
        "Maximum Frequency Response": "40 kilohertz",
        "Impedance": "32 ohms",
        "Sensitivity": "100 decibels adjusted",
        "Driver Size": "40 millimeters",
        "Bluetooth Version": "5.2",
        "Connector Size": "3mm",
        "Detachable Cord": "Yes",
        "Customizable Lighting": "Yes",
        "Lighting Type": "RGB",
        "Foldable Design": "Yes",
        "On/Off Switch": "Yes",
        "feature": [
            "Super Fast Transmission",
            "Superior Sound Quality",
            "Precise Acoustic Positioning",
            "Dual-Mic Enc",
            "Long Playback Time",
            "Comfortable And Foldable",
            "Cyber Rgb Lighting Effects",
            "Wireless/Wired Cross-Platform Compatibility"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767569/headphone/slupxsydpj01qt9qdhff.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/razer-kraken-v3-x-wired-gaming-headset-fortnite-edition-blue/6586274.p?skuId=6586274",
        "name": "Razer - Kraken V3 X Wired Gaming Headset - Fortnite Edition - Blue",
        "model": "RZ04-03750500-R3M1",
        "Noise Cancelling (Active)": "No",
        "Sound Mode": "Stereo",
        "Connection Type": "Wired",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Noise cancelling",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Compatible Platform(s)": "Windows, Mac",
        "Works With": "Cortana",
        "Product Name": "Kraken V3 X Wired Gaming Headset - Fortnite Edition",
        "Brand": "Razer",
        "Model Number": "RZ04-03750500-R3M1",
        "Color": "Blue",
        "Sound Isolating": "Yes",
        "Environmental Noise Control": "Yes",
        "Minimum Frequency Response": "12 hertz",
        "Maximum Frequency Response": "28 kilohertz",
        "Impedance": "32 ohms",
        "Sensitivity": "103 decibels adjusted",
        "Integrated Amplifier": "No",
        "Driver Size": "40 millimeters",
        "Connector Size": "USB-A",
        "Controls": "Mute, Volume",
        "Customizable Lighting": "Yes",
        "Lighting Type": "RGB",
        "High Resolution Audio": "7.1 surround sound",
        "Foldable Design": "No",
        "feature": [
            "285g Ultra-Light Build For Marathon Gaming Sessions",
            "Razer Triforce 40mm Drivers For High-End Audio Performance",
            "Razer Hyperclear Cardioid Mic For Enhanced Voice Capture",
            "Hybrid Fabric And Memory Foam Ear Cushions For Breathable, Long-Lasting Comfort",
            "7.1 Surround Sound For Accurate Positional Audio",
            "Bonus In-Game Item: Raptor Glider"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767570/headphone/y2jhyoyediexwgiierkz.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/astro-gaming-a50-gen-4-wireless-gaming-headset-for-xbox-one-xbox-series-xs-and-pc-black/6349970.p?skuId=6349970",
        "name": "Astro Gaming - A50 Gen 4 Wireless Gaming Headset for Xbox One, Xbox Series X|S, and PC - Black",
        "model": "939-001680",
        "Noise Cancelling (Active)": "No",
        "Sound Mode": "Dolby Atmos",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Radio Frequency (RF)",
        "Maximum Wireless Range": "30 feet",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Adjustable",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "15 hours",
        "Compatible Platform(s)": "Xbox One, Xbox Series S, Xbox Series X, Windows, Mac",
        "Product Name": "A50 Gen 4 Wireless Gaming Headset for Xbox One, Xbox Series X|S, and PC",
        "Brand": "Astro Gaming",
        "Model Number": "939-001680",
        "Color": "Black",
        "Sound Isolating": "Yes",
        "Environmental Noise Control": "No",
        "Minimum Frequency Response": "20 hertz",
        "Maximum Frequency Response": "20 kilohertz",
        "Impedance": "48 ohms",
        "Sensitivity": "118 decibels adjusted",
        "Driver Size": "40 millimeters",
        "Controls": "Mute, Volume",
        "Lighting Type": "None",
        "Foldable Design": "No",
        "feature": [
            "Astro Audio V2",
            "Dolby Audio",
            "Up To 15+ Hours Of Battery Life",
            "Compatibility",
            "Game:Voice Balance",
            "Astro Command Centre Software",
            "Usb Sound Card Functionality",
            "More Sustainable"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767571/headphone/i1qdreqrmvz1cy5p3fab.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/turtle-beach-stealth-600-gen-2-max-wireless-multiplatform-gaming-headset-for-xbox-ps5-ps4-nintendo-switch-and-pc-48-hour-battery-black/6500885.p?skuId=6500885",
        "name": "Turtle Beach - Stealth 600 Gen 2 MAX Wireless Multiplatform Gaming Headset for Xbox, PS5, PS4, Nintendo Switch and PC - 48 Hour Battery - Black",
        "model": "TBS-2362-01",
        "Sound Mode": "Stereo, Simulated Surround, Dolby Atmos, DTS Headphone:X",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Radio Frequency (RF)",
        "Maximum Wireless Range": "30 feet",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Adjustable, Noise cancelling",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "48 hours",
        "Compatible Platform(s)": "Xbox Series X, Xbox Series S, Xbox One, PlayStation 5, PlayStation 4, Windows, Nintendo Switch, Nintendo Switch Lite, Nintendo Switch – OLED Model, Mac, Mac/Windows",
        "Product Name": "Stealth 600 Gen 2 MAX Wireless Multiplatform Gaming Headset for Xbox, PS5, PS4, Nintendo Switch and PC - 48 Hour Battery",
        "Brand": "Turtle Beach",
        "Model Number": "TBS-2362-01",
        "Color": "Black",
        "Sound Isolating": "Yes",
        "Minimum Frequency Response": "20 hertz",
        "Maximum Frequency Response": "20 kilohertz",
        "Impedance": "32 ohms",
        "Sensitivity": "99.95 decibels adjusted",
        "Integrated Amplifier": "Yes",
        "Driver Size": "50 millimeters",
        "Controls": "Volume, Mute",
        "Lighting Type": "None",
        "Foldable Design": "No",
        "On/Off Switch": "Yes",
        "feature": [
            "Officially Licensed For Xbox",
            "Maximum Game Time",
            "Maximum Compatibility",
            "Lag-Free Wireless",
            "Optimized For Surround Sound",
            "Powerful, Amplified Audio",
            "Gen 2 Flip-To-Mute Mic",
            "Better Fit, Bigger Sound",
            "Glasses Friendly",
            "Easy Access To Audio Presets",
            "Superhuman Hearing Sound Setting",
            "Mic Monitoring",
            "Game & Chat Volume Control*",
            "Built To Last",
            "Usb-C Charging"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767572/headphone/reqyz9u19wzhdkitsegl.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/corsair-hs65-surround-wired-gaming-headset-for-pc-ps5-and-ps4-black/6506908.p?skuId=6506908",
        "name": "CORSAIR - HS65 SURROUND Wired Gaming Headset for PC, PS5, and PS4 - Black",
        "model": "CA-9011270-NA",
        "Noise Cancelling (Active)": "Yes",
        "Sound Mode": "Dolby Atmos",
        "Connection Type": "Wired",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Adjustable",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Compatible Platform(s)": "Windows, Mac, PlayStation 5, PlayStation 4, Nintendo Switch",
        "Product Name": "HS65 SURROUND Wired Gaming Headset for PC, PS5, and PS4",
        "Brand": "CORSAIR",
        "Model Number": "CA-9011270-NA",
        "Color": "Black",
        "Sound Isolating": "No",
        "Environmental Noise Control": "Yes",
        "Minimum Frequency Response": "20 hertz",
        "Maximum Frequency Response": "20 kilohertz",
        "Impedance": "32 ohms",
        "Sensitivity": "114 decibels adjusted",
        "Driver Size": "50 millimeters",
        "Connector Size": "USB-A, 1/8 in. (3.5mm)",
        "Detachable Cord": "No",
        "Controls": "Mute, Volume",
        "Lighting Type": "None",
        "Foldable Design": "No",
        "feature": [
            "Great Gaming Audio",
            "Dolby Audio 7.1 Surround Sound On Pc And Mac",
            "Sonarworks Soundid Technology",
            "Easy-Access On-Ear Volume Control",
            "Multi-Platform Compatibility",
            "Discord-Certified",
            "Omni-Directional Microphone",
            "Hours Of Comfortable Gaming",
            "Unite Your Setup"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767573/headphone/k8e3kpw91en09ltowyhs.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/tronsmart-sounfii-g10-wired-gaming-headset-for-nintendo-switch-xbox-series-xs-xbox-one-ps5-ps4-playstation-mobile-pc-black-red-blue-for-nintendo-switch/6607600.p?skuId=6607600",
        "name": "Tronsmart - Sounfii G10 Wired Gaming Headset for Nintendo Switch, Xbox Series X|S, Xbox One, PS5, PS4, PlayStation, Mobile & PC - Black/Red/Blue for Nintendo Switch",
        "model": "1237166",
        "Sound Mode": "Stereo",
        "Connection Type": "Wired",
        "Built-In Microphone": "Yes",
        "Microphone Features": "Flip to mute",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Compatible Platform(s)": "Mac/Windows, PlayStation 5, PlayStation 4, Nintendo Switch, Xbox Series S, Xbox Series X",
        "Product Name": "Sounfii G10 Wired Gaming Headset for Nintendo Switch, Xbox Series X|S, Xbox One, PS5, PS4, PlayStation, Mobile & PC",
        "Brand": "Tronsmart",
        "Model Number": "1237166",
        "Color": "Multi",
        "Sound Isolating": "Yes",
        "Minimum Frequency Response": "20 hertz",
        "Maximum Frequency Response": "20 kilohertz",
        "Driver Size": "40 millimeters",
        "Connector Size": "1/8 in. (3.5mm)",
        "Controls": "Volume, Mute",
        "Foldable Design": "No",
        "feature": [
            "Tronsmart Sounfii G10 Black/Red/Blue For Nintendo Switch",
            "Almighty Audio",
            "Volume Wheel",
            "Crystal-Clear Communication",
            "Ultimate Comfort",
            "Comfort Is King",
            "Super Lightweight & Slim",
            "Built To Last",
            "Wide Compatibility"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767574/headphone/ovavuxg9uvwycbqijems.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/alienware-dual-mode-wireless-gaming-headset-for-xbox-playstation-and-switch-lunar-light/6561709.p?skuId=6561709",
        "name": "Alienware - Dual Mode Wireless Gaming Headset for Xbox, PlayStation and Switch - Lunar Light",
        "model": "AW720H-L",
        "Noise Cancelling (Active)": "No",
        "Sound Mode": "Dolby Atmos",
        "Connection Type": "Wired, Wireless",
        "Wireless Connectivity": "Radio Frequency (RF - 2.4 Ghz/Low Latency)",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Retractable",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "30 hours",
        "Battery Charge Time": "2.5 hours",
        "Compatible Platform(s)": "PlayStation, Xbox, Nintendo Switch",
        "Product Name": "Dual Mode Wireless Gaming Headset for Xbox, PlayStation and Switch",
        "Brand": "Alienware",
        "Model Number": "AW720H-L",
        "Color": "White",
        "Sound Isolating": "No",
        "Environmental Noise Control": "Yes",
        "Minimum Frequency Response": "20 hertz",
        "Maximum Frequency Response": "40 kilohertz",
        "Impedance": "32 ohms",
        "Sensitivity": "-45 decibels adjusted",
        "Integrated Amplifier": "No",
        "Driver Size": "40 millimeters",
        "Connector Size": "1/8 in. (3.5mm)",
        "Detachable Cord": "Yes",
        "Controls": "Volume, Mute",
        "Customizable Lighting": "Yes",
        "Lighting Type": "RGB",
        "High Resolution Audio": "40mm Hi-Res Drivers",
        "Foldable Design": "No",
        "Fast Charging": "USB",
        "On/Off Switch": "Yes",
        "feature": [
            "Dual Mode Connectivity",
            "Tactile Controls",
            "Tuned For Comfort",
            "Spacious. Breathable. Soft.",
            "Immersive Gaming Audio",
            "Hear Every Detail",
            "Issue Clear Commands",
            "Impressive Battery Life",
            "Premium Style",
            "Find Your Perfect Mix"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767575/headphone/lkn6wqr6yxkldcak46in.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/edifier-g5bt-cat-wireless-gaming-headset-w-magnetic-cat-ears-36-hour-battery-life-for-xbox-playstation-nintendo-mobile-pc-sky-blue/6584546.p?skuId=6584546",
        "name": "Edifier - G5BT CAT Wireless Gaming Headset w/ Magnetic Cat Ears, 36 Hour Battery Life for Xbox, Playstation, Nintendo, Mobile & PC - Sky Blue",
        "model": "G5BT CAT SKY BLUE",
        "Connection Type": "Wireless, Wired",
        "Wireless Connectivity": "Bluetooth",
        "Maximum Wireless Range": "32.8 feet",
        "Built-In Microphone": "Yes",
        "Microphone Features": "Noise cancelling, Retractable",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "36 hours",
        "Battery Charge Time": "8 hours",
        "Compatible Platform(s)": "Universal",
        "Product Name": "G5BT CAT Wireless Gaming Headset w/ Magnetic Cat Ears, 36 Hour Battery Life for Xbox, Playstation, Nintendo, Mobile & PC",
        "Brand": "Edifier",
        "Model Number": "G5BT CAT SKY BLUE",
        "Color": "Blue",
        "Sound Isolating": "No",
        "Minimum Frequency Response": "20 hertz",
        "Maximum Frequency Response": "40 kilohertz",
        "Impedance": "32 ohms",
        "Sensitivity": "100 decibels adjusted",
        "Driver Size": "40 millimeters",
        "Bluetooth Version": "5.2",
        "Connector Size": "3mm",
        "Detachable Cord": "Yes",
        "Customizable Lighting": "Yes",
        "Lighting Type": "RGB",
        "Foldable Design": "Yes",
        "On/Off Switch": "Yes",
        "feature": [
            "Cute/Cool Magnetic Cat Ears",
            "45ms Low Latency",
            "Superb Sound Quality",
            "Precise Acoustic Positioning",
            "All Day Comfort",
            "36 Hours Of Extended Battery Life",
            "Dual-Mic Enc",
            "Wireless/Wired Cross-Platform Compatibility"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767575/headphone/pj0to5qy6qzpx69yduhu.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/nzxt-relay-wired-gaming-headset-for-pc-black/6549325.p?skuId=6549325",
        "name": "NZXT - Relay Wired Gaming Headset for PC - Black",
        "model": "AP-WCB40-B2",
        "Connection Type": "Wired",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Detachable",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Product Name": "Relay Wired Gaming Headset for PC",
        "Brand": "NZXT",
        "Model Number": "AP-WCB40-B2",
        "Color": "Black",
        "Sound Isolating": "Yes",
        "Connector Size": "USB Type A",
        "Controls": "Mute, Volume",
        "Lighting Type": "None",
        "High Resolution Audio": "Yes",
        "feature": [
            "Best In Class Sound",
            "Low Distortion Drivers",
            "Dts Heaphone: X",
            "Clear Call-Outs",
            "Universal Comfort"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767576/headphone/m7klrjsxob2xasjbvlbw.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/alienware-pro-wireless-gaming-headset-for-ps5-ps4-and-switch-lunar-light/6605024.p?skuId=6605024",
        "name": "Alienware - Pro Wireless Gaming Headset for PS5, PS4 and Switch - Lunar Light",
        "model": "BBY-AWProH-L",
        "Noise Cancelling (Active)": "Yes",
        "Sound Mode": "Dolby Atmos",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Bluetooth",
        "Maximum Wireless Range": "100 feet",
        "Carrying Case": "No",
        "Built-In Microphone": "Yes",
        "Microphone Features": "Noise cancelling, Detachable",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "No",
        "Battery Life": "75 hours",
        "Battery Charge Time": "0.25 hours",
        "Compatible Platform(s)": "Nintendo Switch, PlayStation 4, PlayStation 5",
        "Product Name": "Pro Wireless Gaming Headset for PS5, PS4 and Switch",
        "Brand": "Alienware",
        "Model Number": "BBY-AWProH-L",
        "Color": "White",
        "Sound Isolating": "No",
        "Impedance": "32 ohms",
        "Bluetooth Version": "5.3",
        "feature": [
            "Tailor Your Sound",
            "Active Noise Cancellation",
            "50mm Graphene-Coated Drivers",
            "Audio Quality Endorsed By The Pros"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767577/headphone/ip0cje5aoemuvqifvnls.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/astro-gaming-a20-gen-2-wireless-gaming-headset-for-xbox-one-xbox-series-xs-pc-white-green/6423471.p?skuId=6423471",
        "name": "Astro Gaming - A20 Gen 2 Wireless Gaming Headset for Xbox One, Xbox Series X|S, PC - White/Green",
        "model": "939-001882",
        "Noise Cancelling (Active)": "No",
        "Sound Mode": "Dolby Atmos",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Radio Frequency (RF)",
        "Maximum Wireless Range": "50 feet",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Retractable",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "15 hours",
        "Battery Charge Time": "3.5 hours",
        "Compatible Platform(s)": "Mac/Windows, Xbox One, Xbox Series X, Xbox Series S",
        "Product Name": "A20 Gen 2 Wireless Gaming Headset for Xbox One, Xbox Series X|S, PC",
        "Brand": "Astro Gaming",
        "Model Number": "939-001882",
        "Color": "White",
        "Sound Isolating": "Yes",
        "Environmental Noise Control": "No",
        "Minimum Frequency Response": "20 hertz",
        "Maximum Frequency Response": "20 kilohertz",
        "Impedance": "32 ohms",
        "Sensitivity": "100 decibels adjusted",
        "Driver Size": "40 millimeters",
        "Controls": "Mute, Volume",
        "Lighting Type": "None",
        "Foldable Design": "No",
        "On/Off Switch": "Yes",
        "feature": [
            "Up To 50ft Wireless Range",
            "Eq Presets",
            "Up To 15+ Hours Battery Life",
            "Compatible With Xbox Series X|S And Xbox One Gaming Consoles",
            "Flip-To-Mute Microphone",
            "Game:Voice Balance",
            "More Sustainable"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767578/headphone/zelxhxp1fqr6ltqsgds1.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/turtle-beach-stealth-600-wireless-gaming-headset-for-xbox-series-xs-pc-ps5-ps4-nintendo-switch-with-80-hr-battery-black/6577968.p?skuId=6577968",
        "name": "Turtle Beach - Stealth™ 600 Wireless Gaming Headset for Xbox Series X|S, PC, PS5, PS4, Nintendo Switch with 80-Hr Battery - Black",
        "model": "TBS-2102-05",
        "Sound Mode": "Stereo",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Radio Frequency (RF - 2.4 Ghz/Low Latency), Bluetooth",
        "Carrying Case": "No",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Compatible Platform(s)": "Xbox Series X, Xbox Series S, Xbox One, Windows, PlayStation 5, PlayStation 4, Nintendo Switch – OLED Model, Nintendo Switch, Steam Deck, iOS, Android",
        "Product Name": "Stealth™ 600 Wireless Gaming Headset for Xbox Series X|S, PC, PS5, PS4, Nintendo Switch with 80-Hr Battery",
        "Brand": "Turtle Beach",
        "Model Number": "TBS-2102-05",
        "Color": "Black",
        "Sound Isolating": "Yes",
        "Driver Size": "50 millimeters",
        "Controls": "Volume",
        "Lighting Type": "None",
        "Foldable Design": "Yes",
        "On/Off Switch": "Yes",
        "feature": [
            "Multiplatform Wireless + Bluetooth",
            "Quickswitch Technology",
            "Unstoppable, 80-Hour Battery Life",
            "A.I.-Based Mic Noise Reduction",
            "Amplified 50mm Nanoclear Drivers",
            "Anywhere Audio Customization",
            "Advanced 10-Band Eq And Microphone Enhancements",
            "Remappable Wheel & Mode Button",
            "Advanced Superhuman Hearing®",
            "Easy Access To Audio Presets",
            "Variable Mic Monitoring",
            "Non-Stop Comfort"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767579/headphone/unjex4zeoxh0gsmx6log.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/logitech-g935-wireless-gaming-headset-for-pc-black-blue/6320787.p?skuId=6320787",
        "name": "Logitech - G935 Wireless Gaming Headset for PC - Black/Blue",
        "model": "981-000742",
        "Noise Cancelling (Active)": "No",
        "Sound Mode": "DTS Headphone:X 2.0",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Radio Frequency (RF)",
        "Maximum Wireless Range": "66 feet",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Adjustable",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "12 hours",
        "Battery Charge Time": "3.5 hours",
        "Compatible Platform(s)": "Mac, Windows",
        "Product Name": "G935 Wireless Gaming Headset for PC",
        "Brand": "Logitech",
        "Model Number": "981-000742",
        "Color": "Multi",
        "Sound Isolating": "No",
        "Minimum Frequency Response": "20 hertz",
        "Maximum Frequency Response": "20 kilohertz",
        "Impedance": "39 ohms",
        "Sensitivity": "93 decibels adjusted",
        "Driver Size": "50 millimeters",
        "Controls": "Volume",
        "Customizable Lighting": "Yes",
        "Lighting Type": "RGB",
        "Foldable Design": "No",
        "On/Off Switch": "Yes",
        "feature": [
            "Up To 12 Hours Battery And Up To 66” Range",
            "Console Compatible",
            "50 Mm Pro-G Drivers",
            "Loud And Clear 6 Mm Mic+",
            "Full-Spectrum Lightsync Rgb",
            "Immersive Dts Headphone: X 2.0 Surround Sound",
            "More Sustainable"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767580/headphone/nn5lyffisgdcashharsp.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/corsair-hs80-rgb-wireless-gaming-headset-for-pc-mac-ps5-ps4-carbon/6470491.p?skuId=6470491",
        "name": "CORSAIR - HS80 RGB Wireless Gaming Headset for PC, Mac, PS5, PS4 - Carbon",
        "model": "CA-9011235-NA",
        "Noise Cancelling (Active)": "No",
        "Sound Mode": "Dolby Atmos",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Radio Frequency (RF)",
        "Maximum Wireless Range": "60 feet",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Fixed",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "20 hours",
        "Battery Charge Time": "2 hours",
        "Compatible Platform(s)": "Mac/Windows, PlayStation 5, PlayStation 4",
        "Product Name": "HS80 RGB Wireless Gaming Headset for PC, Mac, PS5, PS4",
        "Brand": "CORSAIR",
        "Model Number": "CA-9011235-NA",
        "Color": "Black",
        "Sound Isolating": "No",
        "Environmental Noise Control": "No",
        "Minimum Frequency Response": "20 hertz",
        "Maximum Frequency Response": "40 kilohertz",
        "Impedance": "32 ohms",
        "Sensitivity": "109 decibels adjusted",
        "Driver Size": "50 millimeters",
        "Controls": "Mute, Volume",
        "Customizable Lighting": "Yes",
        "Lighting Type": "RGB",
        "Foldable Design": "No",
        "On/Off Switch": "Yes",
        "feature": [
            "Live The Game",
            "Hyper-Fast Slipstream Wireless",
            "Immersive Dolby Atmos On Pc",
            "Catch Every Sound",
            "Broadcast-Grade Omni-Directional Microphone",
            "Hours Of Long-Lasting Plush Comfort",
            "High-Fidelity 24bit/96khz Sound Via Usb",
            "Durable Construction",
            "Wireless Freedom",
            "Discord-Certified",
            "On-Ear Volume And Mute Controls",
            "Dynamic Rgb Lighting",
            "Powerful Corsair Icue Software",
            "Ps5 And Ps4 Wireless Compatibility"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767581/headphone/r1pq8ukog3dwzc3oxeah.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/turtle-beach-stealth-700-gen-2-max-ps-wireless-gaming-headset-for-ps5-ps4-nintendo-switch-pc-black/6513645.p?skuId=6513645",
        "name": "Turtle Beach - Stealth™ 700 Gen 2 MAX PS Wireless Gaming Headset for PS5, PS4, Nintendo Switch, PC - Black",
        "model": "TBS-3790-01",
        "Sound Mode": "Stereo, Simulated Surround, Dolby Atmos, DTS Headphone:X",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Radio Frequency (RF)",
        "Maximum Wireless Range": "30 feet",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Adjustable, Noise cancelling",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "40 hours",
        "Compatible Platform(s)": "PlayStation 5, PlayStation 4, Windows, Nintendo Switch, Nintendo Switch Lite, Nintendo Switch – OLED Model, Mac, Mac/Windows, Android, iOS",
        "Product Name": "Stealth™ 700 Gen 2 MAX PS Wireless Gaming Headset for PS5, PS4, Nintendo Switch, PC",
        "Brand": "Turtle Beach",
        "Model Number": "TBS-3790-01",
        "Color": "Black",
        "Sound Isolating": "Yes",
        "Minimum Frequency Response": "20 hertz",
        "Maximum Frequency Response": "20 kilohertz",
        "Impedance": "32 ohms",
        "Sensitivity": "99.95 decibels adjusted",
        "Integrated Amplifier": "Yes",
        "Driver Size": "50 millimeters",
        "Controls": "Volume, Mute",
        "Lighting Type": "None",
        "Foldable Design": "No",
        "On/Off Switch": "Yes",
        "feature": [
            "Maximum Game Time",
            "Maximum Compatibility",
            "Lag-Free Wireless",
            "Game And Stay Connected With Bluetooth",
            "Aerofit Cooling Gel-Infused Comfort",
            "The 3d Audio Advantage",
            "High-Performance Nanoclear Speakers",
            "Gen 2 Flip-To-Mute Mic",
            "Metal-Reinforced Headband Construction",
            "App-Based Audio",
            "Glasses Friendly",
            "Superhuman Hearing Sound Setting",
            "Variable Mic Monitoring",
            "Easy Access To Audio Presets",
            "Usb-C Charging"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767582/headphone/anyxbyaj2uzrrabatdha.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/hyperx-cloud-stinger-2-core-wired-gaming-headset-for-pc-black/6522922.p?skuId=6522922",
        "name": "HyperX - Cloud Stinger 2 Core Wired Gaming Headset for PC - Black",
        "model": "683L9AA",
        "Noise Cancelling (Active)": "No",
        "Sound Mode": "DTS Headphone:X, Surround",
        "Connection Type": "Wired",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Noise cancelling, Flip to mute",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Compatible Platform(s)": "Windows",
        "Product Name": "Cloud Stinger 2 Core Wired Gaming Headset for PC",
        "Brand": "HyperX",
        "Model Number": "683L9AA",
        "Color": "Black",
        "Sound Isolating": "No",
        "Environmental Noise Control": "No",
        "Minimum Frequency Response": "10 hertz",
        "Maximum Frequency Response": "25 kilohertz",
        "Impedance": "32.5 ohms",
        "Sensitivity": "95 decibels adjusted",
        "Integrated Amplifier": "No",
        "Driver Size": "40 millimeters",
        "Connector Size": "1/8 in. (3.5mm)",
        "Detachable Cord": "No",
        "Controls": "Volume",
        "Lighting Type": "None",
        "High Resolution Audio": "No",
        "Foldable Design": "No",
        "feature": [
            "Dts Headphone:X Spatial Audio",
            "Crisp, Clear In-Game Sound",
            "Improved In-Game Chat Experience",
            "Easy-Access Audio Controls"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767583/headphone/vvs6qdinl7fmguwy58zn.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/corsair-void-rgb-elite-wireless-gaming-headset-for-pc-ps5-ps4-carbon/6360425.p?skuId=6360425",
        "name": "CORSAIR - VOID RGB ELITE Wireless Gaming Headset for PC, PS5, PS4 - Carbon",
        "model": "CA-9011201-NA",
        "Noise Cancelling (Active)": "No",
        "Sound Mode": "Stereo",
        "Connection Type": "Wireless",
        "Wireless Connectivity": "Radio Frequency (RF - 2.4 Ghz/Low Latency)",
        "Maximum Wireless Range": "40 feet",
        "Built-In Microphone": "Yes",
        "Carrying Case": "No",
        "Microphone Features": "Fixed, Flip to mute",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "No",
        "Battery Life": "16 hours",
        "Battery Charge Time": "2 hours",
        "Compatible Platform(s)": "PlayStation 4, Windows, PlayStation 5",
        "Product Name": "VOID RGB ELITE Wireless Gaming Headset for PC, PS5, PS4",
        "Brand": "CORSAIR",
        "Model Number": "CA-9011201-NA",
        "Color": "Black",
        "Sound Isolating": "No",
        "Environmental Noise Control": "Yes",
        "Minimum Frequency Response": "20 hertz",
        "Maximum Frequency Response": "30 kilohertz",
        "Impedance": "32 ohms",
        "Sensitivity": "116 decibels adjusted",
        "Driver Size": "50 millimeters",
        "Controls": "Mute, Volume",
        "Customizable Lighting": "Yes",
        "Lighting Type": "RGB",
        "Foldable Design": "No",
        "On/Off Switch": "No",
        "feature": [
            "Rechargeable Battery",
            "Built-In Microphone",
            "Headset Controls"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767584/headphone/f3rs7kufel7ltwqqjthx.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/asus-rog-delta-ii-wireless-gaming-headset-for-pc-xbox-ps5-and-switch-black/6606317.p?skuId=6606317",
        "name": "ASUS - ROG Delta II Wireless Gaming Headset for PC, Xbox, PS5 and Switch - Black",
        "model": "ROG DELTA II A701",
        "Noise Cancelling (Active)": "No",
        "Sound Mode": "Surround 7.1",
        "Connection Type": "Wireless, Wired",
        "Wireless Connectivity": "Radio Frequency (RF - 2.4 Ghz/Low Latency), Bluetooth",
        "Built-In Microphone": "Yes",
        "Microphone Features": "Detachable",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Battery Life": "110 hours",
        "Battery Charge Time": "2 hours",
        "Compatible Platform(s)": "Windows, Mac, PlayStation 5, Xbox Series X, Xbox Series S",
        "Product Name": "ROG Delta II Wireless Gaming Headset for PC, Xbox, PS5 and Switch",
        "Brand": "ASUS",
        "Model Number": "ROG DELTA II A701",
        "Color": "Black",
        "Sound Isolating": "No",
        "Driver Size": "50 millimeters",
        "Connector Size": "1/8 in. (3.5mm)",
        "Detachable Cord": "Yes",
        "Controls": "Volume, Call, Mute",
        "Customizable Lighting": "Yes",
        "Lighting Type": "RGB",
        "Foldable Design": "Yes",
        "feature": [
            "Versatile Tri-Mode Connectivity",
            "Extreme Audio Quality",
            "Incredible Audio Immersion",
            "10 Mm Super-Wideband Boom Microphone",
            "Dualflow Audio",
            "Exceptional Battery Life And Fast Charging",
            "Perfect Comfort"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767585/headphone/akqffsguevzxy29iwvbx.webp"
    },
    {
        "link": "https://www.bestbuy.com/site/corsair-virtuoso-pro-wired-open-back-streaming-gaming-headset-for-pc-mac-ps5-ps4-xbox-switch-and-mobile-carbon/6562867.p?skuId=6562867",
        "name": "CORSAIR - VIRTUOSO PRO Wired Open Back Streaming/Gaming Headset for PC, Mac, PS5, PS4, Xbox, Switch, and Mobile - Carbon",
        "model": "CA-9011370-NA",
        "Noise Cancelling (Active)": "Yes",
        "Sound Mode": "Stereo",
        "Connection Type": "Wired",
        "Built-In Microphone": "Yes",
        "Carrying Case": "Yes",
        "Microphone Features": "Detachable",
        "Headphone Fit": "Over-the-Ear",
        "Adjustable Headband": "Yes",
        "Compatible Platform(s)": "Windows, Mac, PlayStation 5, PlayStation 4, Xbox Series X, Xbox Series S, Nintendo Switch",
        "Product Name": "VIRTUOSO PRO Wired Open Back Streaming/Gaming Headset for PC, Mac, PS5, PS4, Xbox, Switch, and Mobile",
        "Brand": "CORSAIR",
        "Model Number": "CA-9011370-NA",
        "Color": "Black",
        "Sound Isolating": "No",
        "Environmental Noise Control": "No",
        "Minimum Frequency Response": "20 hertz",
        "Maximum Frequency Response": "40 kilohertz",
        "Impedance": "32 ohms",
        "Sensitivity": "116 decibels adjusted",
        "Driver Size": "50 millimeters",
        "Connector Size": "1/8 in. (3.5mm)",
        "Detachable Cord": "No",
        "Controls": "Mute, Volume",
        "Lighting Type": "None",
        "Foldable Design": "No",
        "feature": [
            "Hear What Matters",
            "Airy Open Back Design",
            "State-Of-The-Art 50mm Graphene Drivers",
            "Works With Elgato Wave Link",
            "Nvidia Broadcast And Vst Software Compatibility",
            "Radically Clear Uni-Directional Microphone",
            "Cool And Light Listening",
            "Premium Construction",
            "Wide Plug-And-Play Connectivity"
        ],
        "imageUrl": "https://res.cloudinary.com/drxrnh0o3/image/upload/v1738767585/headphone/dytd0uuzbhwdufxszjds.webp"
    }
]



const ProductTable = () => {
    const [sorting, setSorting] = useState([]);  // Sorting state

    const table = useReactTable({
        data,
        columns,
        getCoreRowModel: getCoreRowModel(),
        getSortedRowModel: getSortedRowModel(),
        state: {
            sorting,    // Add sorting state
        },
        onSortingChange: setSorting,  // Add sorting state setter
        enableMultiSort: true,        // Enable multi-column sorting
        manualSorting: false,         // Set to true if handling server-side sorting
    });



    return (
        <>
            <Typography variant="h4">Product List</Typography>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                    {table.getHeaderGroups().map(headerGroup => (
                        <tr key={headerGroup.id}>
                            {headerGroup.headers.map(header => (
                                <th
                                    key={header.id}
                                    onClick={header.column.getToggleSortingHandler()}
                                    style={{
                                        cursor: 'pointer',
                                        border: '1px solid #ddd',
                                        padding: '8px',
                                        minWidth: header.column.columnDef.minSize,
                                        maxWidth: header.column.columnDef.maxSize,
                                        width: header.column.columnDef.size || "auto",
                                    }}
                                >
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        {flexRender(
                                            header.column.columnDef.header,
                                            header.getContext()
                                        )}
                                        {{
                                            asc: ' 🔼',
                                            desc: ' 🔽',
                                        }[header.column.getIsSorted()] ?? null}
                                        {/* Show sort priority */}
                                        {header.column.getIsSorted() && table.getState().sorting.length > 1 && (
                                            ` (${header.column.getSortIndex() + 1})`
                                        )}
                                    </div>
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody>
                    {table.getRowModel().rows.map((row) => (
                        <tr key={row.id}>
                            {row.getVisibleCells().map((cell) => (
                                <td
                                    key={cell.id}
                                    style={{
                                        border: "1px solid #ddd",
                                        padding: "8px",
                                    }}
                                >
                                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </>
    );
};


export default ProductTable;
